// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-300.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-600.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/open-sans/fonts/open-sans-v17-latin-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/inter/fonts/Inter-Regular.woff2?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/inter/fonts/Inter-Regular.woff?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/inter/fonts/Inter-Italic.woff2?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/inter/fonts/Inter-Italic.woff?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/inter/fonts/Inter-Medium.woff2?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/fonts/inter/fonts/Inter-Medium.woff?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/fonts/inter/fonts/Inter-MediumItalic.woff2?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/fonts/inter/fonts/Inter-MediumItalic.woff?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../assets/fonts/inter/fonts/Inter-Bold.woff2?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../assets/fonts/inter/fonts/Inter-Bold.woff?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../assets/fonts/inter/fonts/Inter-BoldItalic.woff2?v=3.19", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../assets/fonts/inter/fonts/Inter-BoldItalic.woff?v=3.19", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* open-sans-300 - latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  src: local("Open Sans Light"), local("OpenSans-Light"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}
/* open-sans-regular - latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  src: local("Open Sans Regular"), local("OpenSans-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}
/* open-sans-600 - latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  src: local("Open Sans SemiBold"), local("OpenSans-SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}
/* open-sans-700 - latin */
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  src: local("Open Sans SemiBold"), local("OpenSans-SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}
@font-face {
  font-display: swap;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
}
@font-face {
  font-display: swap;
  font-family: Inter;
  font-style: italic;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
}
@font-face {
  font-display: swap;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
}
@font-face {
  font-display: swap;
  font-family: Inter;
  font-style: italic;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
}
@font-face {
  font-display: swap;
  font-family: Inter;
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
}
@font-face {
  font-display: swap;
  font-family: Inter;
  font-style: italic;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff");
}
/* modern-normalize v2.0.0 | https://github.com/sindresorhus/modern-normalize */
*,
::before,
::after {
  box-sizing: border-box;
  /* Disable touch non-standard gestures and also prevent delay in user actions. */
  touch-action: manipulation;
  /* Reset webkit focus outline */
}
*:focus,
::before:focus,
::after:focus {
  outline: none;
}

html {
  font-family: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  line-height: 1.15;
  tab-size: 4;
  -webkit-text-size-adjust: 100%;
          text-size-adjust: 100%;
}

body {
  margin: 0;
}

hr {
  color: inherit;
  height: 0;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

table {
  border-color: inherit;
  text-indent: 0;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

button,
select {
  text-transform: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
          appearance: button;
}

::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

:-moz-focusring {
  outline: 1px dotted ButtonText;
}

:-moz-ui-invalid {
  box-shadow: none;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
          appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
          appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
          appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

/* Reset webkit autofill appearance */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  background-color: transparent !important;
  box-shadow: 0 0 0 1000px white inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* =============================================
=         Design System Color Palette         =
============================================= */
.color.ocean-50 {
  color: #e6f2ff;
}

.color.ocean-100 {
  color: #e6f2ff;
}

.color.ocean-200 {
  color: #b3daff;
}

.color.ocean-300 {
  color: #7abfff;
}

.color.ocean-400 {
  color: #2392fb;
}

.color.ocean-500 {
  color: #0074e0;
}

.color.ocean-600 {
  color: #043571;
}

.color.space-50 {
  color: #f0f0f0;
}

.color.space-100 {
  color: #e3e3e3;
}

.color.space-200 {
  color: #bfbfbf;
}

.color.space-300 {
  color: gray;
}

.color.space-400 {
  color: #616161;
}

.color.space-500 {
  color: #283439;
}

.color.gray-50 {
  color: #eff3f6;
}

.color.gray-100 {
  color: #e6ecef;
}

.color.gray-200 {
  color: #cfd8de;
}

.color.gray-300 {
  color: #a8b9c2;
}

.color.gray-400 {
  color: #7e98a5;
}

.color.gray-500 {
  color: #738f9c;
}

.color.green-50 {
  color: #e3fdf6;
}

.color.green-100 {
  color: #c5f6ea;
}

.color.green-200 {
  color: #69ddc2;
}

.color.green-300 {
  color: #45bfa3;
}

.color.green-400 {
  color: #1cab8a;
}

.color.green-500 {
  color: #128268;
}

.color.red-50 {
  color: #fff0f3;
}

.color.red-100 {
  color: #f9d2db;
}

.color.red-200 {
  color: #f8b4c4;
}

.color.red-300 {
  color: #e85e81;
}

.color.red-400 {
  color: #e23661;
}

.color.red-500 {
  color: #b82348;
}

.color.yellow-50 {
  color: #fffae6;
}

.color.yellow-100 {
  color: #fff0b3;
}

.color.yellow-200 {
  color: #ffe380;
}

.color.yellow-300 {
  color: #ffcf57;
}

.color.yellow-400 {
  color: #ffc60a;
}

.color.yellow-500 {
  color: #ffb700;
}

.color.orange-50 {
  color: #fff2eb;
}

.color.orange-100 {
  color: #ffe4d6;
}

.color.orange-200 {
  color: #ffc69e;
}

.color.orange-300 {
  color: #ffa047;
}

.color.orange-400 {
  color: #ff7b42;
}

.color.orange-500 {
  color: #ee4920;
}

.color.turquoise-50 {
  color: transparent;
}

.color.turquoise-100 {
  color: #e6fcff;
}

.color.turquoise-200 {
  color: #b3f5ff;
}

.color.turquoise-300 {
  color: #78e2f2;
}

.color.turquoise-400 {
  color: #00c7e6;
}

.color.turquoise-500 {
  color: transparent;
}

.color.turquoise-600 {
  color: transparent;
}

.color.violet-50 {
  color: #eae6ff;
}

.color.violet-100 {
  color: #d9d1ff;
}

.color.violet-200 {
  color: #bfb3ff;
}

.color.violet-300 {
  color: #9d90ea;
}

.color.violet-400 {
  color: #8678d9;
}

.color.violet-500 {
  color: #6f5ccc;
}

.color.snow-50 {
  color: white;
}

.color.snow-100 {
  color: #f7f7f7;
}

.color.snow-200 {
  color: #f0efef;
}

.color.snow-300 {
  color: #e6e6e6;
}

.color.snow-400 {
  color: #e1e0e0;
}

.color.snow-500 {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.background-color.ocean {
  background-color: #2392fb;
  color: white;
}

.background-color.ocean-light {
  background-color: #b3daff;
  color: white;
}

.background-color.green {
  background-color: #1cab8a;
  color: white;
}

.background-color.green-light {
  background-color: #69ddc2;
  color: white;
}

.background-color.red {
  background-color: #e23661;
  color: white;
}

.background-color.red-light {
  background-color: #f8b4c4;
  color: white;
}

.background-color.orange {
  background-color: #ff7b42;
  color: white;
}

.background-color.orange-light {
  background-color: #ffc69e;
  color: white;
}

.background-color.space {
  background-color: #616161;
  color: white;
}

.background-color.space-light {
  background-color: #bfbfbf;
  color: #616161;
}

.background-color.gray-light {
  background-color: #f0efef;
  color: #616161;
}

.background-color.violet {
  background-color: #8678d9;
  color: white;
}

.background-color.violet-light {
  background-color: #bfb3ff;
  color: #616161;
}

.background-color.yellow {
  background-color: #ffc60a;
  color: white;
}

.background-color.yellow-light {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
/* TODO: The way I used displays here is not the best approach;
 * it'll simply fail for something like \`flex item xs-0 md-1\`.
 * It's just a temporary solution.
*/
.flex {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.flex.inline {
  display: inline-flex;
  width: auto;
}
.flex.auto-width {
  width: auto;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
  height: 100%;
  width: auto;
}
.flex.column-reverse {
  flex-direction: column-reverse;
}
.flex.reverse {
  flex-direction: row-reverse;
}
.flex.nowrap {
  flex-wrap: nowrap;
}
.flex.wrap-reverse {
  flex-wrap: wrap-reverse;
}
.flex.items-start {
  align-items: flex-start;
}
.flex.items-end {
  align-items: flex-end;
}
.flex.items-center {
  align-items: center;
}
.flex.items-baseline {
  align-items: baseline;
}
.flex.items-stretch {
  align-items: stretch;
}
.flex.content-start {
  align-content: flex-start;
}
.flex.content-end {
  align-content: flex-end;
}
.flex.content-center {
  align-content: center;
}
.flex.content-between {
  align-content: space-between;
}
.flex.content-around {
  align-content: space-around;
}
.flex.content-evenly {
  align-content: space-evenly;
}
.flex.justify-start {
  justify-content: flex-start;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-between {
  justify-content: space-between;
}
.flex.justify-around {
  justify-content: space-around;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.space-1 {
  margin: -4px;
  width: calc(100% + 8px);
}
.flex.space-1 > .item {
  padding: 4px;
}
.flex.space-2 {
  margin: -8px;
  width: calc(100% + 16px);
}
.flex.space-2 > .item {
  padding: 8px;
}
.flex.space-3 {
  margin: -12px;
  width: calc(100% + 24px);
}
.flex.space-3 > .item {
  padding: 12px;
}
.flex.space-4 {
  margin: -16px;
  width: calc(100% + 32px);
}
.flex.space-4 > .item {
  padding: 16px;
}
.flex.space-5 {
  margin: -20px;
  width: calc(100% + 40px);
}
.flex.space-5 > .item {
  padding: 20px;
}
.flex.space-6 {
  margin: -24px;
  width: calc(100% + 48px);
}
.flex.space-6 > .item {
  padding: 24px;
}
.flex.space-7 {
  margin: -28px;
  width: calc(100% + 56px);
}
.flex.space-7 > .item {
  padding: 28px;
}
.flex.space-8 {
  margin: -32px;
  width: calc(100% + 64px);
}
.flex.space-8 > .item {
  padding: 32px;
}
.flex.space-9 {
  margin: -36px;
  width: calc(100% + 72px);
}
.flex.space-9 > .item {
  padding: 36px;
}
.flex.space-10 {
  margin: -40px;
  width: calc(100% + 80px);
}
.flex.space-10 > .item {
  padding: 40px;
}
.flex > .item {
  box-sizing: border-box;
}
.flex > .item.zero-min-width {
  min-width: 0 !important;
}
.flex > .item.xs {
  display: initial;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.flex > .item.xs.flex {
  display: flex;
}
.flex > .item.xs-auto {
  display: initial;
  flex-basis: auto;
  flex-grow: 0;
  max-width: none;
}
.flex > .item.xs-auto.flex {
  display: flex;
}
.flex > .item.xs-fill {
  display: initial;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.flex > .item.xs-fill.flex {
  display: flex;
}
.flex > .item.xs-0 {
  display: none;
}
.flex > .item.xs-0.flex {
  display: none;
}
.flex > .item.xs-1 {
  display: initial;
  flex-basis: 8.33333%;
  flex-grow: 0;
  max-width: 8.33333%;
}
.flex > .item.xs-1.flex {
  display: flex;
}
.flex > .item.xs-2 {
  display: initial;
  flex-basis: 16.66667%;
  flex-grow: 0;
  max-width: 16.66667%;
}
.flex > .item.xs-2.flex {
  display: flex;
}
.flex > .item.xs-3 {
  display: initial;
  flex-basis: 25%;
  flex-grow: 0;
  max-width: 25%;
}
.flex > .item.xs-3.flex {
  display: flex;
}
.flex > .item.xs-4 {
  display: initial;
  flex-basis: 33.33333%;
  flex-grow: 0;
  max-width: 33.33333%;
}
.flex > .item.xs-4.flex {
  display: flex;
}
.flex > .item.xs-5 {
  display: initial;
  flex-basis: 41.66667%;
  flex-grow: 0;
  max-width: 41.66667%;
}
.flex > .item.xs-5.flex {
  display: flex;
}
.flex > .item.xs-6 {
  display: initial;
  flex-basis: 50%;
  flex-grow: 0;
  max-width: 50%;
}
.flex > .item.xs-6.flex {
  display: flex;
}
.flex > .item.xs-7 {
  display: initial;
  flex-basis: 58.33333%;
  flex-grow: 0;
  max-width: 58.33333%;
}
.flex > .item.xs-7.flex {
  display: flex;
}
.flex > .item.xs-8 {
  display: initial;
  flex-basis: 66.66667%;
  flex-grow: 0;
  max-width: 66.66667%;
}
.flex > .item.xs-8.flex {
  display: flex;
}
.flex > .item.xs-9 {
  display: initial;
  flex-basis: 75%;
  flex-grow: 0;
  max-width: 75%;
}
.flex > .item.xs-9.flex {
  display: flex;
}
.flex > .item.xs-10 {
  display: initial;
  flex-basis: 83.33333%;
  flex-grow: 0;
  max-width: 83.33333%;
}
.flex > .item.xs-10.flex {
  display: flex;
}
.flex > .item.xs-11 {
  display: initial;
  flex-basis: 91.66667%;
  flex-grow: 0;
  max-width: 91.66667%;
}
.flex > .item.xs-11.flex {
  display: flex;
}
.flex > .item.xs-12 {
  display: initial;
  flex-basis: 100%;
  flex-grow: 0;
  max-width: 100%;
}
.flex > .item.xs-12.flex {
  display: flex;
}
@media (min-width: 600px) {
  .flex > .item.sm {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.sm.flex {
    display: flex;
  }
  .flex > .item.sm-auto {
    display: initial;
    flex-basis: auto;
    flex-grow: 0;
    max-width: none;
  }
  .flex > .item.sm-auto.flex {
    display: flex;
  }
  .flex > .item.sm-fill {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.sm-fill.flex {
    display: flex;
  }
  .flex > .item.sm-0 {
    display: none;
  }
  .flex > .item.sm-0.flex {
    display: none;
  }
  .flex > .item.sm-1 {
    display: initial;
    flex-basis: 8.33333%;
    flex-grow: 0;
    max-width: 8.33333%;
  }
  .flex > .item.sm-1.flex {
    display: flex;
  }
  .flex > .item.sm-2 {
    display: initial;
    flex-basis: 16.66667%;
    flex-grow: 0;
    max-width: 16.66667%;
  }
  .flex > .item.sm-2.flex {
    display: flex;
  }
  .flex > .item.sm-3 {
    display: initial;
    flex-basis: 25%;
    flex-grow: 0;
    max-width: 25%;
  }
  .flex > .item.sm-3.flex {
    display: flex;
  }
  .flex > .item.sm-4 {
    display: initial;
    flex-basis: 33.33333%;
    flex-grow: 0;
    max-width: 33.33333%;
  }
  .flex > .item.sm-4.flex {
    display: flex;
  }
  .flex > .item.sm-5 {
    display: initial;
    flex-basis: 41.66667%;
    flex-grow: 0;
    max-width: 41.66667%;
  }
  .flex > .item.sm-5.flex {
    display: flex;
  }
  .flex > .item.sm-6 {
    display: initial;
    flex-basis: 50%;
    flex-grow: 0;
    max-width: 50%;
  }
  .flex > .item.sm-6.flex {
    display: flex;
  }
  .flex > .item.sm-7 {
    display: initial;
    flex-basis: 58.33333%;
    flex-grow: 0;
    max-width: 58.33333%;
  }
  .flex > .item.sm-7.flex {
    display: flex;
  }
  .flex > .item.sm-8 {
    display: initial;
    flex-basis: 66.66667%;
    flex-grow: 0;
    max-width: 66.66667%;
  }
  .flex > .item.sm-8.flex {
    display: flex;
  }
  .flex > .item.sm-9 {
    display: initial;
    flex-basis: 75%;
    flex-grow: 0;
    max-width: 75%;
  }
  .flex > .item.sm-9.flex {
    display: flex;
  }
  .flex > .item.sm-10 {
    display: initial;
    flex-basis: 83.33333%;
    flex-grow: 0;
    max-width: 83.33333%;
  }
  .flex > .item.sm-10.flex {
    display: flex;
  }
  .flex > .item.sm-11 {
    display: initial;
    flex-basis: 91.66667%;
    flex-grow: 0;
    max-width: 91.66667%;
  }
  .flex > .item.sm-11.flex {
    display: flex;
  }
  .flex > .item.sm-12 {
    display: initial;
    flex-basis: 100%;
    flex-grow: 0;
    max-width: 100%;
  }
  .flex > .item.sm-12.flex {
    display: flex;
  }
}
@media (min-width: 960px) {
  .flex > .item.md {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.md.flex {
    display: flex;
  }
  .flex > .item.md-auto {
    display: initial;
    flex-basis: auto;
    flex-grow: 0;
    max-width: none;
  }
  .flex > .item.md-auto.flex {
    display: flex;
  }
  .flex > .item.md-fill {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.md-fill.flex {
    display: flex;
  }
  .flex > .item.md-0 {
    display: none;
  }
  .flex > .item.md-0.flex {
    display: none;
  }
  .flex > .item.md-1 {
    display: initial;
    flex-basis: 8.33333%;
    flex-grow: 0;
    max-width: 8.33333%;
  }
  .flex > .item.md-1.flex {
    display: flex;
  }
  .flex > .item.md-2 {
    display: initial;
    flex-basis: 16.66667%;
    flex-grow: 0;
    max-width: 16.66667%;
  }
  .flex > .item.md-2.flex {
    display: flex;
  }
  .flex > .item.md-3 {
    display: initial;
    flex-basis: 25%;
    flex-grow: 0;
    max-width: 25%;
  }
  .flex > .item.md-3.flex {
    display: flex;
  }
  .flex > .item.md-4 {
    display: initial;
    flex-basis: 33.33333%;
    flex-grow: 0;
    max-width: 33.33333%;
  }
  .flex > .item.md-4.flex {
    display: flex;
  }
  .flex > .item.md-5 {
    display: initial;
    flex-basis: 41.66667%;
    flex-grow: 0;
    max-width: 41.66667%;
  }
  .flex > .item.md-5.flex {
    display: flex;
  }
  .flex > .item.md-6 {
    display: initial;
    flex-basis: 50%;
    flex-grow: 0;
    max-width: 50%;
  }
  .flex > .item.md-6.flex {
    display: flex;
  }
  .flex > .item.md-7 {
    display: initial;
    flex-basis: 58.33333%;
    flex-grow: 0;
    max-width: 58.33333%;
  }
  .flex > .item.md-7.flex {
    display: flex;
  }
  .flex > .item.md-8 {
    display: initial;
    flex-basis: 66.66667%;
    flex-grow: 0;
    max-width: 66.66667%;
  }
  .flex > .item.md-8.flex {
    display: flex;
  }
  .flex > .item.md-9 {
    display: initial;
    flex-basis: 75%;
    flex-grow: 0;
    max-width: 75%;
  }
  .flex > .item.md-9.flex {
    display: flex;
  }
  .flex > .item.md-10 {
    display: initial;
    flex-basis: 83.33333%;
    flex-grow: 0;
    max-width: 83.33333%;
  }
  .flex > .item.md-10.flex {
    display: flex;
  }
  .flex > .item.md-11 {
    display: initial;
    flex-basis: 91.66667%;
    flex-grow: 0;
    max-width: 91.66667%;
  }
  .flex > .item.md-11.flex {
    display: flex;
  }
  .flex > .item.md-12 {
    display: initial;
    flex-basis: 100%;
    flex-grow: 0;
    max-width: 100%;
  }
  .flex > .item.md-12.flex {
    display: flex;
  }
}
@media (min-width: 1280px) {
  .flex > .item.lg {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.lg.flex {
    display: flex;
  }
  .flex > .item.lg-auto {
    display: initial;
    flex-basis: auto;
    flex-grow: 0;
    max-width: none;
  }
  .flex > .item.lg-auto.flex {
    display: flex;
  }
  .flex > .item.lg-fill {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.lg-fill.flex {
    display: flex;
  }
  .flex > .item.lg-0 {
    display: none;
  }
  .flex > .item.lg-0.flex {
    display: none;
  }
  .flex > .item.lg-1 {
    display: initial;
    flex-basis: 8.33333%;
    flex-grow: 0;
    max-width: 8.33333%;
  }
  .flex > .item.lg-1.flex {
    display: flex;
  }
  .flex > .item.lg-2 {
    display: initial;
    flex-basis: 16.66667%;
    flex-grow: 0;
    max-width: 16.66667%;
  }
  .flex > .item.lg-2.flex {
    display: flex;
  }
  .flex > .item.lg-3 {
    display: initial;
    flex-basis: 25%;
    flex-grow: 0;
    max-width: 25%;
  }
  .flex > .item.lg-3.flex {
    display: flex;
  }
  .flex > .item.lg-4 {
    display: initial;
    flex-basis: 33.33333%;
    flex-grow: 0;
    max-width: 33.33333%;
  }
  .flex > .item.lg-4.flex {
    display: flex;
  }
  .flex > .item.lg-5 {
    display: initial;
    flex-basis: 41.66667%;
    flex-grow: 0;
    max-width: 41.66667%;
  }
  .flex > .item.lg-5.flex {
    display: flex;
  }
  .flex > .item.lg-6 {
    display: initial;
    flex-basis: 50%;
    flex-grow: 0;
    max-width: 50%;
  }
  .flex > .item.lg-6.flex {
    display: flex;
  }
  .flex > .item.lg-7 {
    display: initial;
    flex-basis: 58.33333%;
    flex-grow: 0;
    max-width: 58.33333%;
  }
  .flex > .item.lg-7.flex {
    display: flex;
  }
  .flex > .item.lg-8 {
    display: initial;
    flex-basis: 66.66667%;
    flex-grow: 0;
    max-width: 66.66667%;
  }
  .flex > .item.lg-8.flex {
    display: flex;
  }
  .flex > .item.lg-9 {
    display: initial;
    flex-basis: 75%;
    flex-grow: 0;
    max-width: 75%;
  }
  .flex > .item.lg-9.flex {
    display: flex;
  }
  .flex > .item.lg-10 {
    display: initial;
    flex-basis: 83.33333%;
    flex-grow: 0;
    max-width: 83.33333%;
  }
  .flex > .item.lg-10.flex {
    display: flex;
  }
  .flex > .item.lg-11 {
    display: initial;
    flex-basis: 91.66667%;
    flex-grow: 0;
    max-width: 91.66667%;
  }
  .flex > .item.lg-11.flex {
    display: flex;
  }
  .flex > .item.lg-12 {
    display: initial;
    flex-basis: 100%;
    flex-grow: 0;
    max-width: 100%;
  }
  .flex > .item.lg-12.flex {
    display: flex;
  }
}
@media (min-width: 1920px) {
  .flex > .item.xl {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.xl.flex {
    display: flex;
  }
  .flex > .item.xl-auto {
    display: initial;
    flex-basis: auto;
    flex-grow: 0;
    max-width: none;
  }
  .flex > .item.xl-auto.flex {
    display: flex;
  }
  .flex > .item.xl-fill {
    display: initial;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .flex > .item.xl-fill.flex {
    display: flex;
  }
  .flex > .item.xl-0 {
    display: none;
  }
  .flex > .item.xl-0.flex {
    display: none;
  }
  .flex > .item.xl-1 {
    display: initial;
    flex-basis: 8.33333%;
    flex-grow: 0;
    max-width: 8.33333%;
  }
  .flex > .item.xl-1.flex {
    display: flex;
  }
  .flex > .item.xl-2 {
    display: initial;
    flex-basis: 16.66667%;
    flex-grow: 0;
    max-width: 16.66667%;
  }
  .flex > .item.xl-2.flex {
    display: flex;
  }
  .flex > .item.xl-3 {
    display: initial;
    flex-basis: 25%;
    flex-grow: 0;
    max-width: 25%;
  }
  .flex > .item.xl-3.flex {
    display: flex;
  }
  .flex > .item.xl-4 {
    display: initial;
    flex-basis: 33.33333%;
    flex-grow: 0;
    max-width: 33.33333%;
  }
  .flex > .item.xl-4.flex {
    display: flex;
  }
  .flex > .item.xl-5 {
    display: initial;
    flex-basis: 41.66667%;
    flex-grow: 0;
    max-width: 41.66667%;
  }
  .flex > .item.xl-5.flex {
    display: flex;
  }
  .flex > .item.xl-6 {
    display: initial;
    flex-basis: 50%;
    flex-grow: 0;
    max-width: 50%;
  }
  .flex > .item.xl-6.flex {
    display: flex;
  }
  .flex > .item.xl-7 {
    display: initial;
    flex-basis: 58.33333%;
    flex-grow: 0;
    max-width: 58.33333%;
  }
  .flex > .item.xl-7.flex {
    display: flex;
  }
  .flex > .item.xl-8 {
    display: initial;
    flex-basis: 66.66667%;
    flex-grow: 0;
    max-width: 66.66667%;
  }
  .flex > .item.xl-8.flex {
    display: flex;
  }
  .flex > .item.xl-9 {
    display: initial;
    flex-basis: 75%;
    flex-grow: 0;
    max-width: 75%;
  }
  .flex > .item.xl-9.flex {
    display: flex;
  }
  .flex > .item.xl-10 {
    display: initial;
    flex-basis: 83.33333%;
    flex-grow: 0;
    max-width: 83.33333%;
  }
  .flex > .item.xl-10.flex {
    display: flex;
  }
  .flex > .item.xl-11 {
    display: initial;
    flex-basis: 91.66667%;
    flex-grow: 0;
    max-width: 91.66667%;
  }
  .flex > .item.xl-11.flex {
    display: flex;
  }
  .flex > .item.xl-12 {
    display: initial;
    flex-basis: 100%;
    flex-grow: 0;
    max-width: 100%;
  }
  .flex > .item.xl-12.flex {
    display: flex;
  }
}
.flex.column > .item.size-auto {
  flex-basis: auto;
  flex-grow: 0;
  max-height: none;
}
.flex.column > .item.size-fill {
  flex-basis: 0;
  flex-grow: 1;
  max-height: 100%;
}
.flex.column > .item.size-0 {
  flex-basis: 0%;
  flex-grow: 0;
  max-height: 0%;
}
.flex.column > .item.size-1 {
  flex-basis: 8.33333%;
  flex-grow: 0;
  max-height: 8.33333%;
}
.flex.column > .item.size-2 {
  flex-basis: 16.66667%;
  flex-grow: 0;
  max-height: 16.66667%;
}
.flex.column > .item.size-3 {
  flex-basis: 25%;
  flex-grow: 0;
  max-height: 25%;
}
.flex.column > .item.size-4 {
  flex-basis: 33.33333%;
  flex-grow: 0;
  max-height: 33.33333%;
}
.flex.column > .item.size-5 {
  flex-basis: 41.66667%;
  flex-grow: 0;
  max-height: 41.66667%;
}
.flex.column > .item.size-6 {
  flex-basis: 50%;
  flex-grow: 0;
  max-height: 50%;
}
.flex.column > .item.size-7 {
  flex-basis: 58.33333%;
  flex-grow: 0;
  max-height: 58.33333%;
}
.flex.column > .item.size-8 {
  flex-basis: 66.66667%;
  flex-grow: 0;
  max-height: 66.66667%;
}
.flex.column > .item.size-9 {
  flex-basis: 75%;
  flex-grow: 0;
  max-height: 75%;
}
.flex.column > .item.size-10 {
  flex-basis: 83.33333%;
  flex-grow: 0;
  max-height: 83.33333%;
}
.flex.column > .item.size-11 {
  flex-basis: 91.66667%;
  flex-grow: 0;
  max-height: 91.66667%;
}
.flex.column > .item.size-12 {
  flex-basis: 100%;
  flex-grow: 0;
  max-height: 100%;
}

.full-width {
  width: 100%;
}

.full-height {
  height: 100%;
}

.inline {
  display: inline;
}

.inline-block {
  display: inline-block;
}

.block {
  display: block;
}

.relative {
  position: relative;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.scrollable {
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}
.scrollable.hide-x {
  overflow-x: hidden;
}
.scrollable.hide-y {
  overflow-y: hidden;
}

/* stylelint-disable-next-line max-line-length */
/* TODO: Having different line-heights causes some UI and spacing issues.
 * They should be consistent. Please investigate this when refactoring/reimplementing the Typography.
*/
.typo-old.h1 {
  font-weight: 600;
  font-size: 4.2857142857rem;
  letter-spacing: -0.03em;
  line-height: 1.36;
}

h1.typo-old {
  font-weight: 600;
  font-size: 4.2857142857rem;
  letter-spacing: -0.03em;
  line-height: 1.36;
}

.typo-old.h2 {
  font-weight: 600;
  font-size: 3.4285714286rem;
  letter-spacing: -0.025;
  line-height: 1.5;
}

h2.typo-old {
  font-weight: 600;
  font-size: 3.4285714286rem;
  letter-spacing: -0.025;
  line-height: 1.5;
}

.typo-old.h3 {
  font-weight: 600;
  font-size: 2.4285714286rem;
  letter-spacing: -0.02em;
  line-height: 1.6;
}

h3.typo-old {
  font-weight: 600;
  font-size: 2.4285714286rem;
  letter-spacing: -0.02em;
  line-height: 1.6;
}

.typo-old.h4 {
  font-weight: 600;
  font-size: 1.7142857143rem;
  letter-spacing: -0.015em;
  line-height: 1.7;
}

h4.typo-old {
  font-weight: 600;
  font-size: 1.7142857143rem;
  letter-spacing: -0.015em;
  line-height: 1.7;
}

.typo-old.h5 {
  font-weight: 600;
  font-size: 1.4285714286rem;
  letter-spacing: -0.0125em;
  line-height: 1.8;
}

h5.typo-old {
  font-weight: 600;
  font-size: 1.4285714286rem;
  letter-spacing: -0.0125em;
  line-height: 1.8;
}

.typo-old.h6 {
  font-weight: 600;
  font-size: 1.1428571429rem;
  letter-spacing: -0.01em;
  line-height: 1.9;
}

h6.typo-old {
  font-weight: 600;
  font-size: 1.1428571429rem;
  letter-spacing: -0.01em;
  line-height: 1.9;
}

.typo-old.subtitle1 {
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.01em;
  line-height: 2;
}

subtitle1.typo-old {
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.01em;
  line-height: 2;
}

.typo-old.subtitle2 {
  font-weight: 600;
  font-size: 0.8571428571rem;
  letter-spacing: 0.02em;
  line-height: 2.15;
}

subtitle2.typo-old {
  font-weight: 600;
  font-size: 0.8571428571rem;
  letter-spacing: 0.02em;
  line-height: 2.15;
}

.typo-old.subtitle3 {
  font-weight: 600;
  font-size: 0.7142857143rem;
  letter-spacing: 0.04em;
  line-height: 2.4;
}

subtitle3.typo-old {
  font-weight: 600;
  font-size: 0.7142857143rem;
  letter-spacing: 0.04em;
  line-height: 2.4;
}

.typo-old.body1 {
  font-size: 1rem;
  letter-spacing: 0.01em;
  line-height: 2;
}

body1.typo-old {
  font-size: 1rem;
  letter-spacing: 0.01em;
  line-height: 2;
}

.typo-old.body2 {
  font-size: 0.8571428571rem;
  letter-spacing: 0.02em;
  line-height: 2.15;
}

body2.typo-old {
  font-size: 0.8571428571rem;
  letter-spacing: 0.02em;
  line-height: 2.15;
}

.typo-old.body3 {
  font-size: 0.7142857143rem;
  letter-spacing: 0.04em;
  line-height: 2.4;
}

body3.typo-old {
  font-size: 0.7142857143rem;
  letter-spacing: 0.04em;
  line-height: 2.4;
}

.typo-old {
  font-family: "Open Sans", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue" !important;
}
.typo-old.weight-light {
  font-weight: 300 !important;
}
.typo-old.weight-normal {
  font-weight: 400 !important;
}
.typo-old.weight-semi-bold {
  font-weight: 600 !important;
}
.typo-old.weight-bold {
  font-weight: 700 !important;
}
.typo-old.nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.typo-old.paragraph {
  margin-bottom: 16px ;
}
.typo-old.gutter-bottom {
  margin-bottom: 0.35em;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.text-justify {
  text-align: justify;
}

.new-typography-wrapper * {
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper h1,
.new-typography-wrapper h2,
.new-typography-wrapper h3,
.new-typography-wrapper h4,
.new-typography-wrapper h5,
.new-typography-wrapper h6,
.new-typography-wrapper p {
  margin: 0;
}
.new-typography-wrapper a {
  color: #0074e0;
}
.new-typography-wrapper a:hover {
  color: #2392fb;
}
.new-typography-wrapper .text-start {
  text-align: start;
}
.new-typography-wrapper .text-end {
  text-align: end;
}
.new-typography-wrapper .text-left {
  text-align: left;
}
.new-typography-wrapper .text-right {
  text-align: right;
}
.new-typography-wrapper .text-center {
  text-align: center;
}
.new-typography-wrapper .text-justify {
  text-align: justify;
}
.new-typography-wrapper .typo.h1 {
  font-weight: 500;
  font-size: 1.7142857143rem;
  letter-spacing: -0.47px;
  line-height: 34px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper h1 {
  font-weight: 500;
  font-size: 1.7142857143rem;
  letter-spacing: -0.47px;
  line-height: 34px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.h2 {
  font-weight: 500;
  font-size: 1.4285714286rem;
  letter-spacing: -0.33px;
  line-height: 30px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper h2 {
  font-weight: 500;
  font-size: 1.4285714286rem;
  letter-spacing: -0.33px;
  line-height: 30px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.h3 {
  font-weight: 400;
  font-size: 1.4285714286rem;
  letter-spacing: -0.33px;
  line-height: 30px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper h3 {
  font-weight: 400;
  font-size: 1.4285714286rem;
  letter-spacing: -0.33px;
  line-height: 30px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.h4 {
  font-weight: 700;
  font-size: 1.1428571429rem;
  letter-spacing: -0.18px;
  line-height: 24px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper h4 {
  font-weight: 700;
  font-size: 1.1428571429rem;
  letter-spacing: -0.18px;
  line-height: 24px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.h5 {
  font-weight: 500;
  font-size: 1.1428571429rem;
  letter-spacing: -0.18px;
  line-height: 24px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper h5 {
  font-weight: 500;
  font-size: 1.1428571429rem;
  letter-spacing: -0.18px;
  line-height: 24px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.body1 {
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper body1 {
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.body2 {
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper body2 {
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.body3 {
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper body3 {
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.info1 {
  font-weight: 700;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper info1 {
  font-weight: 700;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.info2 {
  font-weight: 500;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper info2 {
  font-weight: 500;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper .typo.info3 {
  font-weight: 400;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}
.new-typography-wrapper info3 {
  font-weight: 400;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/open-sans/style.css","webpack://./src/ui-kit/styles/main.scss","webpack://./src/assets/fonts/inter/style.css","webpack://./src/ui-kit/styles/global/normalizer.scss","webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/global/flex.scss","webpack://./src/ui-kit/styles/_theme/_media-query.scss","webpack://./src/ui-kit/styles/global/misc.scss","webpack://./src/ui-kit/styles/_theme/_typography_old.scss","webpack://./src/ui-kit/styles/global/typography_old.scss","webpack://./src/ui-kit/styles/global/typography.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA;EACI,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uKACI;ACAR;ADMA,8BAAA;AACA;EACI,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2KACI;ACLR;ADWA,0BAAA;AACA;EACI,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6KACI;ACVR;ADgBA,0BAAA;AACA;EACI,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6KACI;ACfR;AC3BA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oHACI;AD4BR;ACzBA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sHACI;AD0BR;ACvBA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sHACI;ADwBR;ACrBA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sHACI;ADsBR;ACnBA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sHACI;ADoBR;ACjBA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sHACI;ADkBR;AErEA,+EAAA;AAEA;;;EAGI,sBAAA;EAEA,gFAAA;EACA,0BAAA;EAEA,+BAAA;AFoEJ;AEnEI;;;EACI,aAAA;AFuER;;AEnEA;EACI,+GACI;EAQJ,iBAAA;EACA,WAAA;EACA,8BAAA;UAAA,sBAAA;AF8DJ;;AE3DA;EACI,SAAA;AF8DJ;;AE3DA;EACI,cAAA;EACA,SAAA;AF8DJ;;AE3DA;EACI,yCAAA;UAAA,iCAAA;AF8DJ;;AE3DA;;EAEI,mBAAA;AF8DJ;;AE3DA;;;;EAII,wFACI;EAMJ,cAAA;AFwDJ;;AErDA;EACI,cAAA;AFwDJ;;AErDA;;EAEI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AFwDJ;;AErDA;EACI,eAAA;AFwDJ;;AErDA;EACI,WAAA;AFwDJ;;AErDA;EACI,qBAAA;EACA,cAAA;AFwDJ;;AErDA;;;;;EAKI,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AFwDJ;;AErDA;;EAEI,oBAAA;AFwDJ;;AErDA;;;;EAII,0BAAA;UAAA,kBAAA;AFwDJ;;AErDA;EACI,kBAAA;EACA,UAAA;AFwDJ;;AErDA;EACI,8BAAA;AFwDJ;;AErDA;EACI,gBAAA;AFwDJ;;AErDA;EACI,UAAA;AFwDJ;;AErDA;EACI,wBAAA;AFwDJ;;AErDA;;EAEI,YAAA;AFwDJ;;AErDA;EACI,6BAAA;UAAA,qBAAA;EACA,oBAAA;AFwDJ;;AErDA;EACI,wBAAA;UAAA,gBAAA;AFwDJ;;AErDA;EACI,0BAAA;UAAA,kBAAA;EACA,aAAA;AFwDJ;;AErDA;EACI,kBAAA;AFwDJ;;AErDA,qCAAA;AACA;;;;;;;;;EASI,wCAAA;EACA,oCAAA;EACA,yDAAA;EAAA,iDAAA;AFwDJ;;AG7NA;;+CAAA;AAmFI;EACI,cAjFC;AHiOT;;AGjJI;EACI,cAjFC;AHqOT;;AGrJI;EACI,cAjFC;AHyOT;;AGzJI;EACI,cAjFC;AH6OT;;AG7JI;EACI,cAjFC;AHiPT;;AGjKI;EACI,cAjFC;AHqPT;;AGrKI;EACI,cAjFC;AHyPT;;AGzKI;EACI,cAjFC;AH6PT;;AG7KI;EACI,cAjFC;AHiQT;;AGjLI;EACI,cAjFC;AHqQT;;AGrLI;EACI,WAjFC;AHyQT;;AGzLI;EACI,cAjFC;AH6QT;;AG7LI;EACI,cAjFC;AHiRT;;AGjMI;EACI,cAjFC;AHqRT;;AGrMI;EACI,cAjFC;AHyRT;;AGzMI;EACI,cAjFC;AH6RT;;AG7MI;EACI,cAjFC;AHiST;;AGjNI;EACI,cAjFC;AHqST;;AGrNI;EACI,cAjFC;AHyST;;AGzNI;EACI,cAjFC;AH6ST;;AG7NI;EACI,cAjFC;AHiTT;;AGjOI;EACI,cAjFC;AHqTT;;AGrOI;EACI,cAjFC;AHyTT;;AGzOI;EACI,cAjFC;AH6TT;;AG7OI;EACI,cAjFC;AHiUT;;AGjPI;EACI,cAjFC;AHqUT;;AGrPI;EACI,cAjFC;AHyUT;;AGzPI;EACI,cAjFC;AH6UT;;AG7PI;EACI,cAjFC;AHiVT;;AGjQI;EACI,cAjFC;AHqVT;;AGrQI;EACI,cAjFC;AHyVT;;AGzQI;EACI,cAjFC;AH6VT;;AG7QI;EACI,cAjFC;AHiWT;;AGjRI;EACI,cAjFC;AHqWT;;AGrRI;EACI,cAjFC;AHyWT;;AGzRI;EACI,cAjFC;AH6WT;;AG7RI;EACI,cAjFC;AHiXT;;AGjSI;EACI,cAjFC;AHqXT;;AGrSI;EACI,cAjFC;AHyXT;;AGzSI;EACI,cAjFC;AH6XT;;AG7SI;EACI,cAjFC;AHiYT;;AGjTI;EACI,cAjFC;AHqYT;;AGrTI;EACI,cAjFC;AHyYT;;AGzTI;EACI,kBAjFC;AH6YT;;AG7TI;EACI,cAjFC;AHiZT;;AGjUI;EACI,cAjFC;AHqZT;;AGrUI;EACI,cAjFC;AHyZT;;AGzUI;EACI,cAjFC;AH6ZT;;AG7UI;EACI,kBAjFC;AHiaT;;AGjVI;EACI,kBAjFC;AHqaT;;AGrVI;EACI,cAjFC;AHyaT;;AGzVI;EACI,cAjFC;AH6aT;;AG7VI;EACI,cAjFC;AHibT;;AGjWI;EACI,cAjFC;AHqbT;;AGrWI;EACI,cAjFC;AHybT;;AGzWI;EACI,cAjFC;AH6bT;;AG7WI;EACI,YAjFC;AHicT;;AGjXI;EACI,cAjFC;AHqcT;;AGrXI;EACI,cAjFC;AHycT;;AGzXI;EACI,cAjFC;AH6cT;;AG7XI;EACI,cAjFC;AHidT;;AGjYI;EACI,cAjFC;AHqdT;;AGhYA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AH8TJ;;AG1TI;EALA,yBAAA;EACA,YAAA;AHmUJ;;AG/TI;EALA,yBAAA;EACA,YAAA;AHwUJ;;AGpUI;EALA,yBAAA;EACA,YAAA;AH6UJ;;AGzUI;EALA,yBAAA;EACA,YAAA;AHkVJ;;AG9UI;EALA,yBAAA;EACA,YAAA;AHuVJ;;AGnVI;EALA,yBAAA;EACA,YAAA;AH4VJ;;AGxVI;EALA,yBAAA;EACA,YAAA;AHiWJ;;AG7VI;EALA,yBAAA;EACA,YAAA;AHsWJ;;AGlWI;EALA,yBAAA;EACA,cAAA;AH2WJ;;AGvWI;EALA,yBAAA;EACA,cAAA;AHgXJ;;AG5WI;EALA,yBAAA;EACA,YAAA;AHqXJ;;AGjXI;EALA,yBAAA;EACA,cAAA;AH0XJ;;AGtXI;EALA,yBAAA;EACA,YAAA;AH+XJ;;AG3XI;EALA,yBAAA;EACA,cAAA;AHoYJ;;AIvhBA;;CAAA;ACVA;;;CAAA;AA0DA;EACI,sBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;ALifJ;AK/eI;EACI,oBAAA;EACA,WAAA;ALifR;AK9eI;EACI,WAAA;ALgfR;AK7eI;EACI,mBAAA;AL+eR;AK5eI;EACI,sBAAA;EACA,YAAA;EACA,WAAA;AL8eR;AK5eQ;EACI,8BAAA;AL8eZ;AK1eI;EACI,2BAAA;AL4eR;AKzeI;EACI,iBAAA;AL2eR;AKxeI;EACI,uBAAA;AL0eR;AKveI;EACI,uBAAA;ALyeR;AKteI;EACI,qBAAA;ALweR;AKreI;EACI,mBAAA;ALueR;AKpeI;EACI,qBAAA;ALseR;AKneI;EACI,oBAAA;ALqeR;AKleI;EACI,yBAAA;ALoeR;AKjeI;EACI,uBAAA;ALmeR;AKheI;EACI,qBAAA;ALkeR;AK/dI;EACI,4BAAA;ALieR;AK9dI;EACI,2BAAA;ALgeR;AK7dI;EACI,2BAAA;AL+dR;AK5dI;EACI,2BAAA;AL8dR;AK3dI;EACI,yBAAA;AL6dR;AK1dI;EACI,uBAAA;AL4dR;AKzdI;EACI,8BAAA;AL2dR;AKxdI;EACI,6BAAA;AL0dR;AKvdI;EACI,6BAAA;ALydR;AKpdQ;EACI,YAAA;EACA,uBAAA;ALsdZ;AKpdY;EACI,YANC;AL4djB;AK3dQ;EACI,YAAA;EACA,wBAAA;AL6dZ;AK3dY;EACI,YANC;ALmejB;AKleQ;EACI,aAAA;EACA,wBAAA;ALoeZ;AKleY;EACI,aANC;AL0ejB;AKzeQ;EACI,aAAA;EACA,wBAAA;AL2eZ;AKzeY;EACI,aANC;ALifjB;AKhfQ;EACI,aAAA;EACA,wBAAA;ALkfZ;AKhfY;EACI,aANC;ALwfjB;AKvfQ;EACI,aAAA;EACA,wBAAA;ALyfZ;AKvfY;EACI,aANC;AL+fjB;AK9fQ;EACI,aAAA;EACA,wBAAA;ALggBZ;AK9fY;EACI,aANC;ALsgBjB;AKrgBQ;EACI,aAAA;EACA,wBAAA;ALugBZ;AKrgBY;EACI,aANC;AL6gBjB;AK5gBQ;EACI,aAAA;EACA,wBAAA;AL8gBZ;AK5gBY;EACI,aANC;ALohBjB;AKnhBQ;EACI,aAAA;EACA,wBAAA;ALqhBZ;AKnhBY;EACI,aANC;AL2hBjB;AKhhBI;EACI,sBAAA;ALkhBR;AKhhBQ;EACI,uBAAA;ALkhBZ;AKpsBI;EACI,gBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;ALssBR;AKpsBQ;EACI,aAAA;ALssBZ;AKjsBQ;EAEQ,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;ALksBhB;AKhsBgB;EACI,aAAA;ALksBpB;AK1sBQ;EAWQ,gBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;ALksBhB;AKhsBgB;EACI,aAAA;ALksBpB;AKntBQ;EAoBQ,aAAA;ALksBhB;AKhsBgB;EACI,aAAA;ALksBpB;AKztBQ;EA4BQ,gBAAA;EACA,oBAHQ;EAIR,YAAA;EACA,mBALQ;ALqsBxB;AK9rBgB;EACI,aAAA;ALgsBpB;AKluBQ;EA4BQ,gBAAA;EACA,qBAHQ;EAIR,YAAA;EACA,oBALQ;AL8sBxB;AKvsBgB;EACI,aAAA;ALysBpB;AK3uBQ;EA4BQ,gBAAA;EACA,eAHQ;EAIR,YAAA;EACA,cALQ;ALutBxB;AKhtBgB;EACI,aAAA;ALktBpB;AKpvBQ;EA4BQ,gBAAA;EACA,qBAHQ;EAIR,YAAA;EACA,oBALQ;ALguBxB;AKztBgB;EACI,aAAA;AL2tBpB;AK7vBQ;EA4BQ,gBAAA;EACA,qBAHQ;EAIR,YAAA;EACA,oBALQ;ALyuBxB;AKluBgB;EACI,aAAA;ALouBpB;AKtwBQ;EA4BQ,gBAAA;EACA,eAHQ;EAIR,YAAA;EACA,cALQ;ALkvBxB;AK3uBgB;EACI,aAAA;AL6uBpB;AK/wBQ;EA4BQ,gBAAA;EACA,qBAHQ;EAIR,YAAA;EACA,oBALQ;AL2vBxB;AKpvBgB;EACI,aAAA;ALsvBpB;AKxxBQ;EA4BQ,gBAAA;EACA,qBAHQ;EAIR,YAAA;EACA,oBALQ;ALowBxB;AK7vBgB;EACI,aAAA;AL+vBpB;AKjyBQ;EA4BQ,gBAAA;EACA,eAHQ;EAIR,YAAA;EACA,cALQ;AL6wBxB;AKtwBgB;EACI,aAAA;ALwwBpB;AK1yBQ;EA4BQ,gBAAA;EACA,qBAHQ;EAIR,YAAA;EACA,oBALQ;ALsxBxB;AK/wBgB;EACI,aAAA;ALixBpB;AKnzBQ;EA4BQ,gBAAA;EACA,qBAHQ;EAIR,YAAA;EACA,oBALQ;AL+xBxB;AKxxBgB;EACI,aAAA;AL0xBpB;AK5zBQ;EA4BQ,gBAAA;EACA,gBAHQ;EAIR,YAAA;EACA,eALQ;ALwyBxB;AKjyBgB;EACI,aAAA;ALmyBpB;AMt0BY;EDXR;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;ELo1BN;EKl1BM;IACI,aAAA;ELo1BV;EK/0BM;IAEQ,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;ELg1Bd;EK90Bc;IACI,aAAA;ELg1BlB;EKx1BM;IAWQ,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;ELg1Bd;EK90Bc;IACI,aAAA;ELg1BlB;EKj2BM;IAoBQ,aAAA;ELg1Bd;EK90Bc;IACI,aAAA;ELg1BlB;EKv2BM;IA4BQ,gBAAA;IACA,oBAHQ;IAIR,YAAA;IACA,mBALQ;ELm1BtB;EK50Bc;IACI,aAAA;EL80BlB;EKh3BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL41BtB;EKr1Bc;IACI,aAAA;ELu1BlB;EKz3BM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;ELq2BtB;EK91Bc;IACI,aAAA;ELg2BlB;EKl4BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL82BtB;EKv2Bc;IACI,aAAA;ELy2BlB;EK34BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELu3BtB;EKh3Bc;IACI,aAAA;ELk3BlB;EKp5BM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;ELg4BtB;EKz3Bc;IACI,aAAA;EL23BlB;EK75BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELy4BtB;EKl4Bc;IACI,aAAA;ELo4BlB;EKt6BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELk5BtB;EK34Bc;IACI,aAAA;EL64BlB;EK/6BM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;EL25BtB;EKp5Bc;IACI,aAAA;ELs5BlB;EKx7BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELo6BtB;EK75Bc;IACI,aAAA;EL+5BlB;EKj8BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL66BtB;EKt6Bc;IACI,aAAA;ELw6BlB;EK18BM;IA4BQ,gBAAA;IACA,gBAHQ;IAIR,YAAA;IACA,eALQ;ELs7BtB;EK/6Bc;IACI,aAAA;ELi7BlB;AACF;AMr9BY;EDXR;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;ELm+BN;EKj+BM;IACI,aAAA;ELm+BV;EK99BM;IAEQ,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EL+9Bd;EK79Bc;IACI,aAAA;EL+9BlB;EKv+BM;IAWQ,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EL+9Bd;EK79Bc;IACI,aAAA;EL+9BlB;EKh/BM;IAoBQ,aAAA;EL+9Bd;EK79Bc;IACI,aAAA;EL+9BlB;EKt/BM;IA4BQ,gBAAA;IACA,oBAHQ;IAIR,YAAA;IACA,mBALQ;ELk+BtB;EK39Bc;IACI,aAAA;EL69BlB;EK//BM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL2+BtB;EKp+Bc;IACI,aAAA;ELs+BlB;EKxgCM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;ELo/BtB;EK7+Bc;IACI,aAAA;EL++BlB;EKjhCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL6/BtB;EKt/Bc;IACI,aAAA;ELw/BlB;EK1hCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELsgCtB;EK//Bc;IACI,aAAA;ELigClB;EKniCM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;EL+gCtB;EKxgCc;IACI,aAAA;EL0gClB;EK5iCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELwhCtB;EKjhCc;IACI,aAAA;ELmhClB;EKrjCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELiiCtB;EK1hCc;IACI,aAAA;EL4hClB;EK9jCM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;EL0iCtB;EKniCc;IACI,aAAA;ELqiClB;EKvkCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELmjCtB;EK5iCc;IACI,aAAA;EL8iClB;EKhlCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL4jCtB;EKrjCc;IACI,aAAA;ELujClB;EKzlCM;IA4BQ,gBAAA;IACA,gBAHQ;IAIR,YAAA;IACA,eALQ;ELqkCtB;EK9jCc;IACI,aAAA;ELgkClB;AACF;AMpmCY;EDXR;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;ELknCN;EKhnCM;IACI,aAAA;ELknCV;EK7mCM;IAEQ,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EL8mCd;EK5mCc;IACI,aAAA;EL8mClB;EKtnCM;IAWQ,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EL8mCd;EK5mCc;IACI,aAAA;EL8mClB;EK/nCM;IAoBQ,aAAA;EL8mCd;EK5mCc;IACI,aAAA;EL8mClB;EKroCM;IA4BQ,gBAAA;IACA,oBAHQ;IAIR,YAAA;IACA,mBALQ;ELinCtB;EK1mCc;IACI,aAAA;EL4mClB;EK9oCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL0nCtB;EKnnCc;IACI,aAAA;ELqnClB;EKvpCM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;ELmoCtB;EK5nCc;IACI,aAAA;EL8nClB;EKhqCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL4oCtB;EKroCc;IACI,aAAA;ELuoClB;EKzqCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELqpCtB;EK9oCc;IACI,aAAA;ELgpClB;EKlrCM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;EL8pCtB;EKvpCc;IACI,aAAA;ELypClB;EK3rCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELuqCtB;EKhqCc;IACI,aAAA;ELkqClB;EKpsCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELgrCtB;EKzqCc;IACI,aAAA;EL2qClB;EK7sCM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;ELyrCtB;EKlrCc;IACI,aAAA;ELorClB;EKttCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELksCtB;EK3rCc;IACI,aAAA;EL6rClB;EK/tCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL2sCtB;EKpsCc;IACI,aAAA;ELssClB;EKxuCM;IA4BQ,gBAAA;IACA,gBAHQ;IAIR,YAAA;IACA,eALQ;ELotCtB;EK7sCc;IACI,aAAA;EL+sClB;AACF;AMnvCY;EDXR;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;ELiwCN;EK/vCM;IACI,aAAA;ELiwCV;EK5vCM;IAEQ,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EL6vCd;EK3vCc;IACI,aAAA;EL6vClB;EKrwCM;IAWQ,gBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EL6vCd;EK3vCc;IACI,aAAA;EL6vClB;EK9wCM;IAoBQ,aAAA;EL6vCd;EK3vCc;IACI,aAAA;EL6vClB;EKpxCM;IA4BQ,gBAAA;IACA,oBAHQ;IAIR,YAAA;IACA,mBALQ;ELgwCtB;EKzvCc;IACI,aAAA;EL2vClB;EK7xCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELywCtB;EKlwCc;IACI,aAAA;ELowClB;EKtyCM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;ELkxCtB;EK3wCc;IACI,aAAA;EL6wClB;EK/yCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL2xCtB;EKpxCc;IACI,aAAA;ELsxClB;EKxzCM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELoyCtB;EK7xCc;IACI,aAAA;EL+xClB;EKj0CM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;EL6yCtB;EKtyCc;IACI,aAAA;ELwyClB;EK10CM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELszCtB;EK/yCc;IACI,aAAA;ELizClB;EKn1CM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL+zCtB;EKxzCc;IACI,aAAA;EL0zClB;EK51CM;IA4BQ,gBAAA;IACA,eAHQ;IAIR,YAAA;IACA,cALQ;ELw0CtB;EKj0Cc;IACI,aAAA;ELm0ClB;EKr2CM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;ELi1CtB;EK10Cc;IACI,aAAA;EL40ClB;EK92CM;IA4BQ,gBAAA;IACA,qBAHQ;IAIR,YAAA;IACA,oBALQ;EL01CtB;EKn1Cc;IACI,aAAA;ELq1ClB;EKv3CM;IA4BQ,gBAAA;IACA,gBAHQ;IAIR,YAAA;IACA,eALQ;ELm2CtB;EK51Cc;IACI,aAAA;EL81ClB;AACF;AK1sCY;EAEQ,gBAAA;EACA,YAAA;EACA,gBAAA;AL2sCpB;AK/sCY;EAMQ,aAAA;EACA,YAAA;EACA,gBAAA;AL4sCpB;AKptCY;EAYQ,cAFS;EAGT,YAAA;EACA,cAJS;AL+sC7B;AKztCY;EAYQ,oBAFS;EAGT,YAAA;EACA,oBAJS;ALotC7B;AK9tCY;EAYQ,qBAFS;EAGT,YAAA;EACA,qBAJS;ALytC7B;AKnuCY;EAYQ,eAFS;EAGT,YAAA;EACA,eAJS;AL8tC7B;AKxuCY;EAYQ,qBAFS;EAGT,YAAA;EACA,qBAJS;ALmuC7B;AK7uCY;EAYQ,qBAFS;EAGT,YAAA;EACA,qBAJS;ALwuC7B;AKlvCY;EAYQ,eAFS;EAGT,YAAA;EACA,eAJS;AL6uC7B;AKvvCY;EAYQ,qBAFS;EAGT,YAAA;EACA,qBAJS;ALkvC7B;AK5vCY;EAYQ,qBAFS;EAGT,YAAA;EACA,qBAJS;ALuvC7B;AKjwCY;EAYQ,eAFS;EAGT,YAAA;EACA,eAJS;AL4vC7B;AKtwCY;EAYQ,qBAFS;EAGT,YAAA;EACA,qBAJS;ALiwC7B;AK3wCY;EAYQ,qBAFS;EAGT,YAAA;EACA,qBAJS;ALswC7B;AKhxCY;EAYQ,gBAFS;EAGT,YAAA;EACA,gBAJS;AL2wC7B;;AOp+CA;EACI,WAAA;APu+CJ;;AOp+CA;EACI,YAAA;APu+CJ;;AOn+CA;EACI,eAAA;APs+CJ;;AOn+CA;EACI,qBAAA;APs+CJ;;AOn+CA;EACI,cAAA;APs+CJ;;AOl+CA;EACI,kBAAA;APq+CJ;;AOl+CA;EACI,eAAA;APq+CJ;;AOl+CA;EACI,kBAAA;APq+CJ;;AOj+CA;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iCAAA;EACA,WAAA;APo+CJ;AOl+CI;EACI,kBAAA;APo+CR;AOj+CI;EACI,kBAAA;APm+CR;;AQ7gDA,gDAAA;AASA;;CAAA;ACRI;ED4CA,gBAAA;EAPA,0BAAA;EACA,uBAciB;EAbjB,iBAaiB;ARm+CrB;;ASlhDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,uBAciB;EAbjB,iBAaiB;AR0+CrB;;AS9hDI;ED4CA,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,gBAaiB;ARi/CrB;;AShiDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,gBAaiB;ARw/CrB;;AS5iDI;ED4CA,gBAAA;EAPA,0BAAA;EACA,uBAciB;EAbjB,gBAaiB;AR+/CrB;;AS9iDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,uBAciB;EAbjB,gBAaiB;ARsgDrB;;AS1jDI;ED4CA,gBAAA;EAPA,0BAAA;EACA,wBAciB;EAbjB,gBAaiB;AR6gDrB;;AS5jDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,wBAciB;EAbjB,gBAaiB;ARohDrB;;ASxkDI;ED4CA,gBAAA;EAPA,0BAAA;EACA,yBAciB;EAbjB,gBAaiB;AR2hDrB;;AS1kDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,yBAciB;EAbjB,gBAaiB;ARkiDrB;;AStlDI;ED4CA,gBAAA;EAPA,0BAAA;EACA,uBAciB;EAbjB,gBAaiB;ARyiDrB;;ASxlDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,uBAciB;EAbjB,gBAaiB;ARgjDrB;;ASpmDI;ED4CA,gBAAA;EAPA,eAAA;EACA,sBAciB;EAbjB,cAaiB;ARujDrB;;AStmDQ;EDuCJ,gBAAA;EAPA,eAAA;EACA,sBAciB;EAbjB,cAaiB;AR8jDrB;;ASlnDI;ED4CA,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,iBAaiB;ARqkDrB;;ASpnDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,iBAaiB;AR4kDrB;;AShoDI;ED4CA,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,gBAaiB;ARmlDrB;;ASloDQ;EDuCJ,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,gBAaiB;AR0lDrB;;AS9oDI;EDqCA,eAAA;EACA,sBAciB;EAbjB,cAaiB;ARgmDrB;;AS/oDQ;EDgCJ,eAAA;EACA,sBAciB;EAbjB,cAaiB;ARsmDrB;;AS1pDI;EDqCA,0BAAA;EACA,sBAciB;EAbjB,iBAaiB;AR4mDrB;;AS3pDQ;EDgCJ,0BAAA;EACA,sBAciB;EAbjB,iBAaiB;ARknDrB;;AStqDI;EDqCA,0BAAA;EACA,sBAciB;EAbjB,gBAaiB;ARwnDrB;;ASvqDQ;EDgCJ,0BAAA;EACA,sBAciB;EAbjB,gBAaiB;AR8nDrB;;ASvqDA;EACI,yIAAA;AT0qDJ;ASvqDQ;ED6BJ,2BAAA;AR6oDJ;AS1qDQ;ED6BJ,2BAAA;ARgpDJ;AS7qDQ;ED6BJ,2BAAA;ARmpDJ;AShrDQ;ED6BJ,2BAAA;ARspDJ;AS9qDI;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;ATgrDR;AS7qDI;EACI,oBAAA;AT+qDR;AS5qDI;EACI,qBAAA;AT8qDR;;AStqDI;EACI,gBAJU;AT6qDlB;;AS1qDI;EACI,iBAJU;ATirDlB;;AS9qDI;EACI,kBAJU;ATqrDlB;;ASlrDI;EACI,mBAJU;ATyrDlB;;AU5tDI;EACI,0HCHiB;AXkuDzB;AU5tDI;;;;;;;EAOI,SAAA;AV8tDR;AU3tDI;EACI,cAAA;AV6tDR;AU3tDQ;EACI,cAAA;AV6tDZ;AUxtDQ;EACI,iBA1BU;AVovDtB;AU3tDQ;EACI,eA1BU;AVuvDtB;AU9tDQ;EACI,gBA1BU;AV0vDtB;AUjuDQ;EACI,iBA1BU;AV6vDtB;AUpuDQ;EACI,kBA1BU;AVgwDtB;AUvuDQ;EACI,mBA1BU;AVmwDtB;AUruDQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX0wDzB;AUtuDY;ECWR,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXixDzB;AUnvDQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXwxDzB;AUpvDY;ECWR,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX+xDzB;AUjwDQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXsyDzB;AUlwDY;ECWR,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX6yDzB;AU/wDQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXozDzB;AUhxDY;ECWR,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX2zDzB;AU7xDQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXk0DzB;AU9xDY;ECWR,gBAAA;EANA,0BAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXy0DzB;AU3yDQ;ECiBJ,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXg1DzB;AU5yDY;ECWR,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXu1DzB;AUzzDQ;ECiBJ,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX81DzB;AU1zDY;ECWR,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXq2DzB;AUv0DQ;ECiBJ,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX42DzB;AUx0DY;ECWR,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXm3DzB;AUr1DQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX03DzB;AUt1DY;ECWR,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXi4DzB;AUn2DQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXw4DzB;AUp2DY;ECWR,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX+4DzB;AUj3DQ;ECiBJ,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AXs5DzB;AUl3DY;ECWR,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;AX65DzB;;AUl3DA;ECiBI,gBAAA;EACA,uBAAA;EACA,mBAAA;AXq2DJ","sourcesContent":["/* open-sans-300 - latin */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 300;\n    src:\n        local('Open Sans Light'),\n        local('OpenSans-Light'),\n        url('./fonts/open-sans-v17-latin-300.woff2') format('woff2'),\n        url('./fonts/open-sans-v17-latin-300.woff') format('woff');\n}\n\n/* open-sans-regular - latin */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 400;\n    src:\n        local('Open Sans Regular'),\n        local('OpenSans-Regular'),\n        url('./fonts/open-sans-v17-latin-regular.woff2') format('woff2'),\n        url('./fonts/open-sans-v17-latin-regular.woff') format('woff');\n}\n\n/* open-sans-600 - latin */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 600;\n    src:\n        local('Open Sans SemiBold'),\n        local('OpenSans-SemiBold'),\n        url('./fonts/open-sans-v17-latin-600.woff2') format('woff2'),\n        url('./fonts/open-sans-v17-latin-600.woff') format('woff');\n}\n\n/* open-sans-700 - latin */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 700;\n    src:\n        local('Open Sans SemiBold'),\n        local('OpenSans-SemiBold'),\n        url('./fonts/open-sans-v17-latin-700.woff2') format('woff2'),\n        url('./fonts/open-sans-v17-latin-700.woff') format('woff');\n}\n","/* open-sans-300 - latin */\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 300;\n  src: local(\"Open Sans Light\"), local(\"OpenSans-Light\"), url(\"./fonts/open-sans-v17-latin-300.woff2\") format(\"woff2\"), url(\"./fonts/open-sans-v17-latin-300.woff\") format(\"woff\");\n}\n/* open-sans-regular - latin */\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Open Sans Regular\"), local(\"OpenSans-Regular\"), url(\"./fonts/open-sans-v17-latin-regular.woff2\") format(\"woff2\"), url(\"./fonts/open-sans-v17-latin-regular.woff\") format(\"woff\");\n}\n/* open-sans-600 - latin */\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 600;\n  src: local(\"Open Sans SemiBold\"), local(\"OpenSans-SemiBold\"), url(\"./fonts/open-sans-v17-latin-600.woff2\") format(\"woff2\"), url(\"./fonts/open-sans-v17-latin-600.woff\") format(\"woff\");\n}\n/* open-sans-700 - latin */\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: local(\"Open Sans SemiBold\"), local(\"OpenSans-SemiBold\"), url(\"./fonts/open-sans-v17-latin-700.woff2\") format(\"woff2\"), url(\"./fonts/open-sans-v17-latin-700.woff\") format(\"woff\");\n}\n@font-face {\n  font-display: swap;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"./fonts/Inter-Regular.woff2?v=3.19\") format(\"woff2\"), url(\"./fonts/Inter-Regular.woff?v=3.19\") format(\"woff\");\n}\n@font-face {\n  font-display: swap;\n  font-family: Inter;\n  font-style: italic;\n  font-weight: 400;\n  src: url(\"./fonts/Inter-Italic.woff2?v=3.19\") format(\"woff2\"), url(\"./fonts/Inter-Italic.woff?v=3.19\") format(\"woff\");\n}\n@font-face {\n  font-display: swap;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"./fonts/Inter-Medium.woff2?v=3.19\") format(\"woff2\"), url(\"./fonts/Inter-Medium.woff?v=3.19\") format(\"woff\");\n}\n@font-face {\n  font-display: swap;\n  font-family: Inter;\n  font-style: italic;\n  font-weight: 500;\n  src: url(\"./fonts/Inter-MediumItalic.woff2?v=3.19\") format(\"woff2\"), url(\"./fonts/Inter-MediumItalic.woff?v=3.19\") format(\"woff\");\n}\n@font-face {\n  font-display: swap;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"./fonts/Inter-Bold.woff2?v=3.19\") format(\"woff2\"), url(\"./fonts/Inter-Bold.woff?v=3.19\") format(\"woff\");\n}\n@font-face {\n  font-display: swap;\n  font-family: Inter;\n  font-style: italic;\n  font-weight: 700;\n  src: url(\"./fonts/Inter-BoldItalic.woff2?v=3.19\") format(\"woff2\"), url(\"./fonts/Inter-BoldItalic.woff?v=3.19\") format(\"woff\");\n}\n/* modern-normalize v2.0.0 | https://github.com/sindresorhus/modern-normalize */\n*,\n::before,\n::after {\n  box-sizing: border-box;\n  /* Disable touch non-standard gestures and also prevent delay in user actions. */\n  touch-action: manipulation;\n  /* Reset webkit focus outline */\n}\n*:focus,\n::before:focus,\n::after:focus {\n  outline: none;\n}\n\nhtml {\n  font-family: system-ui, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\";\n  line-height: 1.15;\n  tab-size: 4;\n  text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n}\n\nhr {\n  color: inherit;\n  height: 0;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 1em;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\ntable {\n  border-color: inherit;\n  text-indent: 0;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  appearance: button;\n}\n\n::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\nlegend {\n  padding: 0;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  appearance: textfield;\n  outline-offset: -2px;\n}\n\n::-webkit-search-decoration {\n  appearance: none;\n}\n\n::-webkit-file-upload-button {\n  appearance: button;\n  font: inherit;\n}\n\nsummary {\n  display: list-item;\n}\n\n/* Reset webkit autofill appearance */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  background-color: transparent !important;\n  box-shadow: 0 0 0 1000px white inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n.color.ocean-50 {\n  color: #e6f2ff;\n}\n\n.color.ocean-100 {\n  color: #e6f2ff;\n}\n\n.color.ocean-200 {\n  color: #b3daff;\n}\n\n.color.ocean-300 {\n  color: #7abfff;\n}\n\n.color.ocean-400 {\n  color: #2392fb;\n}\n\n.color.ocean-500 {\n  color: #0074e0;\n}\n\n.color.ocean-600 {\n  color: #043571;\n}\n\n.color.space-50 {\n  color: #f0f0f0;\n}\n\n.color.space-100 {\n  color: #e3e3e3;\n}\n\n.color.space-200 {\n  color: #bfbfbf;\n}\n\n.color.space-300 {\n  color: gray;\n}\n\n.color.space-400 {\n  color: #616161;\n}\n\n.color.space-500 {\n  color: #283439;\n}\n\n.color.gray-50 {\n  color: #eff3f6;\n}\n\n.color.gray-100 {\n  color: #e6ecef;\n}\n\n.color.gray-200 {\n  color: #cfd8de;\n}\n\n.color.gray-300 {\n  color: #a8b9c2;\n}\n\n.color.gray-400 {\n  color: #7e98a5;\n}\n\n.color.gray-500 {\n  color: #738f9c;\n}\n\n.color.green-50 {\n  color: #e3fdf6;\n}\n\n.color.green-100 {\n  color: #c5f6ea;\n}\n\n.color.green-200 {\n  color: #69ddc2;\n}\n\n.color.green-300 {\n  color: #45bfa3;\n}\n\n.color.green-400 {\n  color: #1cab8a;\n}\n\n.color.green-500 {\n  color: #128268;\n}\n\n.color.red-50 {\n  color: #fff0f3;\n}\n\n.color.red-100 {\n  color: #f9d2db;\n}\n\n.color.red-200 {\n  color: #f8b4c4;\n}\n\n.color.red-300 {\n  color: #e85e81;\n}\n\n.color.red-400 {\n  color: #e23661;\n}\n\n.color.red-500 {\n  color: #b82348;\n}\n\n.color.yellow-50 {\n  color: #fffae6;\n}\n\n.color.yellow-100 {\n  color: #fff0b3;\n}\n\n.color.yellow-200 {\n  color: #ffe380;\n}\n\n.color.yellow-300 {\n  color: #ffcf57;\n}\n\n.color.yellow-400 {\n  color: #ffc60a;\n}\n\n.color.yellow-500 {\n  color: #ffb700;\n}\n\n.color.orange-50 {\n  color: #fff2eb;\n}\n\n.color.orange-100 {\n  color: #ffe4d6;\n}\n\n.color.orange-200 {\n  color: #ffc69e;\n}\n\n.color.orange-300 {\n  color: #ffa047;\n}\n\n.color.orange-400 {\n  color: #ff7b42;\n}\n\n.color.orange-500 {\n  color: #ee4920;\n}\n\n.color.turquoise-50 {\n  color: transparent;\n}\n\n.color.turquoise-100 {\n  color: #e6fcff;\n}\n\n.color.turquoise-200 {\n  color: #b3f5ff;\n}\n\n.color.turquoise-300 {\n  color: #78e2f2;\n}\n\n.color.turquoise-400 {\n  color: #00c7e6;\n}\n\n.color.turquoise-500 {\n  color: transparent;\n}\n\n.color.turquoise-600 {\n  color: transparent;\n}\n\n.color.violet-50 {\n  color: #eae6ff;\n}\n\n.color.violet-100 {\n  color: #d9d1ff;\n}\n\n.color.violet-200 {\n  color: #bfb3ff;\n}\n\n.color.violet-300 {\n  color: #9d90ea;\n}\n\n.color.violet-400 {\n  color: #8678d9;\n}\n\n.color.violet-500 {\n  color: #6f5ccc;\n}\n\n.color.snow-50 {\n  color: white;\n}\n\n.color.snow-100 {\n  color: #f7f7f7;\n}\n\n.color.snow-200 {\n  color: #f0efef;\n}\n\n.color.snow-300 {\n  color: #e6e6e6;\n}\n\n.color.snow-400 {\n  color: #e1e0e0;\n}\n\n.color.snow-500 {\n  color: #cfcfcf;\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n.background-color.ocean {\n  background-color: #2392fb;\n  color: white;\n}\n\n.background-color.ocean-light {\n  background-color: #b3daff;\n  color: white;\n}\n\n.background-color.green {\n  background-color: #1cab8a;\n  color: white;\n}\n\n.background-color.green-light {\n  background-color: #69ddc2;\n  color: white;\n}\n\n.background-color.red {\n  background-color: #e23661;\n  color: white;\n}\n\n.background-color.red-light {\n  background-color: #f8b4c4;\n  color: white;\n}\n\n.background-color.orange {\n  background-color: #ff7b42;\n  color: white;\n}\n\n.background-color.orange-light {\n  background-color: #ffc69e;\n  color: white;\n}\n\n.background-color.space {\n  background-color: #616161;\n  color: white;\n}\n\n.background-color.space-light {\n  background-color: #bfbfbf;\n  color: #616161;\n}\n\n.background-color.gray-light {\n  background-color: #f0efef;\n  color: #616161;\n}\n\n.background-color.violet {\n  background-color: #8678d9;\n  color: white;\n}\n\n.background-color.violet-light {\n  background-color: #bfb3ff;\n  color: #616161;\n}\n\n.background-color.yellow {\n  background-color: #ffc60a;\n  color: white;\n}\n\n.background-color.yellow-light {\n  background-color: #ffe380;\n  color: #616161;\n}\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n/* TODO: The way I used displays here is not the best approach;\n * it'll simply fail for something like `flex item xs-0 md-1`.\n * It's just a temporary solution.\n*/\n.flex {\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.flex.inline {\n  display: inline-flex;\n  width: auto;\n}\n.flex.auto-width {\n  width: auto;\n}\n.flex.row {\n  flex-direction: row;\n}\n.flex.column {\n  flex-direction: column;\n  height: 100%;\n  width: auto;\n}\n.flex.column-reverse {\n  flex-direction: column-reverse;\n}\n.flex.reverse {\n  flex-direction: row-reverse;\n}\n.flex.nowrap {\n  flex-wrap: nowrap;\n}\n.flex.wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n.flex.items-start {\n  align-items: flex-start;\n}\n.flex.items-end {\n  align-items: flex-end;\n}\n.flex.items-center {\n  align-items: center;\n}\n.flex.items-baseline {\n  align-items: baseline;\n}\n.flex.items-stretch {\n  align-items: stretch;\n}\n.flex.content-start {\n  align-content: flex-start;\n}\n.flex.content-end {\n  align-content: flex-end;\n}\n.flex.content-center {\n  align-content: center;\n}\n.flex.content-between {\n  align-content: space-between;\n}\n.flex.content-around {\n  align-content: space-around;\n}\n.flex.content-evenly {\n  align-content: space-evenly;\n}\n.flex.justify-start {\n  justify-content: flex-start;\n}\n.flex.justify-end {\n  justify-content: flex-end;\n}\n.flex.justify-center {\n  justify-content: center;\n}\n.flex.justify-between {\n  justify-content: space-between;\n}\n.flex.justify-around {\n  justify-content: space-around;\n}\n.flex.justify-evenly {\n  justify-content: space-evenly;\n}\n.flex.space-1 {\n  margin: -4px;\n  width: calc(100% + 8px);\n}\n.flex.space-1 > .item {\n  padding: 4px;\n}\n.flex.space-2 {\n  margin: -8px;\n  width: calc(100% + 16px);\n}\n.flex.space-2 > .item {\n  padding: 8px;\n}\n.flex.space-3 {\n  margin: -12px;\n  width: calc(100% + 24px);\n}\n.flex.space-3 > .item {\n  padding: 12px;\n}\n.flex.space-4 {\n  margin: -16px;\n  width: calc(100% + 32px);\n}\n.flex.space-4 > .item {\n  padding: 16px;\n}\n.flex.space-5 {\n  margin: -20px;\n  width: calc(100% + 40px);\n}\n.flex.space-5 > .item {\n  padding: 20px;\n}\n.flex.space-6 {\n  margin: -24px;\n  width: calc(100% + 48px);\n}\n.flex.space-6 > .item {\n  padding: 24px;\n}\n.flex.space-7 {\n  margin: -28px;\n  width: calc(100% + 56px);\n}\n.flex.space-7 > .item {\n  padding: 28px;\n}\n.flex.space-8 {\n  margin: -32px;\n  width: calc(100% + 64px);\n}\n.flex.space-8 > .item {\n  padding: 32px;\n}\n.flex.space-9 {\n  margin: -36px;\n  width: calc(100% + 72px);\n}\n.flex.space-9 > .item {\n  padding: 36px;\n}\n.flex.space-10 {\n  margin: -40px;\n  width: calc(100% + 80px);\n}\n.flex.space-10 > .item {\n  padding: 40px;\n}\n.flex > .item {\n  box-sizing: border-box;\n}\n.flex > .item.zero-min-width {\n  min-width: 0 !important;\n}\n.flex > .item.xs {\n  display: initial;\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n.flex > .item.xs.flex {\n  display: flex;\n}\n.flex > .item.xs-auto {\n  display: initial;\n  flex-basis: auto;\n  flex-grow: 0;\n  max-width: none;\n}\n.flex > .item.xs-auto.flex {\n  display: flex;\n}\n.flex > .item.xs-fill {\n  display: initial;\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n.flex > .item.xs-fill.flex {\n  display: flex;\n}\n.flex > .item.xs-0 {\n  display: none;\n}\n.flex > .item.xs-0.flex {\n  display: none;\n}\n.flex > .item.xs-1 {\n  display: initial;\n  flex-basis: 8.33333%;\n  flex-grow: 0;\n  max-width: 8.33333%;\n}\n.flex > .item.xs-1.flex {\n  display: flex;\n}\n.flex > .item.xs-2 {\n  display: initial;\n  flex-basis: 16.66667%;\n  flex-grow: 0;\n  max-width: 16.66667%;\n}\n.flex > .item.xs-2.flex {\n  display: flex;\n}\n.flex > .item.xs-3 {\n  display: initial;\n  flex-basis: 25%;\n  flex-grow: 0;\n  max-width: 25%;\n}\n.flex > .item.xs-3.flex {\n  display: flex;\n}\n.flex > .item.xs-4 {\n  display: initial;\n  flex-basis: 33.33333%;\n  flex-grow: 0;\n  max-width: 33.33333%;\n}\n.flex > .item.xs-4.flex {\n  display: flex;\n}\n.flex > .item.xs-5 {\n  display: initial;\n  flex-basis: 41.66667%;\n  flex-grow: 0;\n  max-width: 41.66667%;\n}\n.flex > .item.xs-5.flex {\n  display: flex;\n}\n.flex > .item.xs-6 {\n  display: initial;\n  flex-basis: 50%;\n  flex-grow: 0;\n  max-width: 50%;\n}\n.flex > .item.xs-6.flex {\n  display: flex;\n}\n.flex > .item.xs-7 {\n  display: initial;\n  flex-basis: 58.33333%;\n  flex-grow: 0;\n  max-width: 58.33333%;\n}\n.flex > .item.xs-7.flex {\n  display: flex;\n}\n.flex > .item.xs-8 {\n  display: initial;\n  flex-basis: 66.66667%;\n  flex-grow: 0;\n  max-width: 66.66667%;\n}\n.flex > .item.xs-8.flex {\n  display: flex;\n}\n.flex > .item.xs-9 {\n  display: initial;\n  flex-basis: 75%;\n  flex-grow: 0;\n  max-width: 75%;\n}\n.flex > .item.xs-9.flex {\n  display: flex;\n}\n.flex > .item.xs-10 {\n  display: initial;\n  flex-basis: 83.33333%;\n  flex-grow: 0;\n  max-width: 83.33333%;\n}\n.flex > .item.xs-10.flex {\n  display: flex;\n}\n.flex > .item.xs-11 {\n  display: initial;\n  flex-basis: 91.66667%;\n  flex-grow: 0;\n  max-width: 91.66667%;\n}\n.flex > .item.xs-11.flex {\n  display: flex;\n}\n.flex > .item.xs-12 {\n  display: initial;\n  flex-basis: 100%;\n  flex-grow: 0;\n  max-width: 100%;\n}\n.flex > .item.xs-12.flex {\n  display: flex;\n}\n@media (min-width: 600px) {\n  .flex > .item.sm {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.sm.flex {\n    display: flex;\n  }\n  .flex > .item.sm-auto {\n    display: initial;\n    flex-basis: auto;\n    flex-grow: 0;\n    max-width: none;\n  }\n  .flex > .item.sm-auto.flex {\n    display: flex;\n  }\n  .flex > .item.sm-fill {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.sm-fill.flex {\n    display: flex;\n  }\n  .flex > .item.sm-0 {\n    display: none;\n  }\n  .flex > .item.sm-0.flex {\n    display: none;\n  }\n  .flex > .item.sm-1 {\n    display: initial;\n    flex-basis: 8.33333%;\n    flex-grow: 0;\n    max-width: 8.33333%;\n  }\n  .flex > .item.sm-1.flex {\n    display: flex;\n  }\n  .flex > .item.sm-2 {\n    display: initial;\n    flex-basis: 16.66667%;\n    flex-grow: 0;\n    max-width: 16.66667%;\n  }\n  .flex > .item.sm-2.flex {\n    display: flex;\n  }\n  .flex > .item.sm-3 {\n    display: initial;\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex > .item.sm-3.flex {\n    display: flex;\n  }\n  .flex > .item.sm-4 {\n    display: initial;\n    flex-basis: 33.33333%;\n    flex-grow: 0;\n    max-width: 33.33333%;\n  }\n  .flex > .item.sm-4.flex {\n    display: flex;\n  }\n  .flex > .item.sm-5 {\n    display: initial;\n    flex-basis: 41.66667%;\n    flex-grow: 0;\n    max-width: 41.66667%;\n  }\n  .flex > .item.sm-5.flex {\n    display: flex;\n  }\n  .flex > .item.sm-6 {\n    display: initial;\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex > .item.sm-6.flex {\n    display: flex;\n  }\n  .flex > .item.sm-7 {\n    display: initial;\n    flex-basis: 58.33333%;\n    flex-grow: 0;\n    max-width: 58.33333%;\n  }\n  .flex > .item.sm-7.flex {\n    display: flex;\n  }\n  .flex > .item.sm-8 {\n    display: initial;\n    flex-basis: 66.66667%;\n    flex-grow: 0;\n    max-width: 66.66667%;\n  }\n  .flex > .item.sm-8.flex {\n    display: flex;\n  }\n  .flex > .item.sm-9 {\n    display: initial;\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex > .item.sm-9.flex {\n    display: flex;\n  }\n  .flex > .item.sm-10 {\n    display: initial;\n    flex-basis: 83.33333%;\n    flex-grow: 0;\n    max-width: 83.33333%;\n  }\n  .flex > .item.sm-10.flex {\n    display: flex;\n  }\n  .flex > .item.sm-11 {\n    display: initial;\n    flex-basis: 91.66667%;\n    flex-grow: 0;\n    max-width: 91.66667%;\n  }\n  .flex > .item.sm-11.flex {\n    display: flex;\n  }\n  .flex > .item.sm-12 {\n    display: initial;\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex > .item.sm-12.flex {\n    display: flex;\n  }\n}\n@media (min-width: 960px) {\n  .flex > .item.md {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.md.flex {\n    display: flex;\n  }\n  .flex > .item.md-auto {\n    display: initial;\n    flex-basis: auto;\n    flex-grow: 0;\n    max-width: none;\n  }\n  .flex > .item.md-auto.flex {\n    display: flex;\n  }\n  .flex > .item.md-fill {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.md-fill.flex {\n    display: flex;\n  }\n  .flex > .item.md-0 {\n    display: none;\n  }\n  .flex > .item.md-0.flex {\n    display: none;\n  }\n  .flex > .item.md-1 {\n    display: initial;\n    flex-basis: 8.33333%;\n    flex-grow: 0;\n    max-width: 8.33333%;\n  }\n  .flex > .item.md-1.flex {\n    display: flex;\n  }\n  .flex > .item.md-2 {\n    display: initial;\n    flex-basis: 16.66667%;\n    flex-grow: 0;\n    max-width: 16.66667%;\n  }\n  .flex > .item.md-2.flex {\n    display: flex;\n  }\n  .flex > .item.md-3 {\n    display: initial;\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex > .item.md-3.flex {\n    display: flex;\n  }\n  .flex > .item.md-4 {\n    display: initial;\n    flex-basis: 33.33333%;\n    flex-grow: 0;\n    max-width: 33.33333%;\n  }\n  .flex > .item.md-4.flex {\n    display: flex;\n  }\n  .flex > .item.md-5 {\n    display: initial;\n    flex-basis: 41.66667%;\n    flex-grow: 0;\n    max-width: 41.66667%;\n  }\n  .flex > .item.md-5.flex {\n    display: flex;\n  }\n  .flex > .item.md-6 {\n    display: initial;\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex > .item.md-6.flex {\n    display: flex;\n  }\n  .flex > .item.md-7 {\n    display: initial;\n    flex-basis: 58.33333%;\n    flex-grow: 0;\n    max-width: 58.33333%;\n  }\n  .flex > .item.md-7.flex {\n    display: flex;\n  }\n  .flex > .item.md-8 {\n    display: initial;\n    flex-basis: 66.66667%;\n    flex-grow: 0;\n    max-width: 66.66667%;\n  }\n  .flex > .item.md-8.flex {\n    display: flex;\n  }\n  .flex > .item.md-9 {\n    display: initial;\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex > .item.md-9.flex {\n    display: flex;\n  }\n  .flex > .item.md-10 {\n    display: initial;\n    flex-basis: 83.33333%;\n    flex-grow: 0;\n    max-width: 83.33333%;\n  }\n  .flex > .item.md-10.flex {\n    display: flex;\n  }\n  .flex > .item.md-11 {\n    display: initial;\n    flex-basis: 91.66667%;\n    flex-grow: 0;\n    max-width: 91.66667%;\n  }\n  .flex > .item.md-11.flex {\n    display: flex;\n  }\n  .flex > .item.md-12 {\n    display: initial;\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex > .item.md-12.flex {\n    display: flex;\n  }\n}\n@media (min-width: 1280px) {\n  .flex > .item.lg {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.lg.flex {\n    display: flex;\n  }\n  .flex > .item.lg-auto {\n    display: initial;\n    flex-basis: auto;\n    flex-grow: 0;\n    max-width: none;\n  }\n  .flex > .item.lg-auto.flex {\n    display: flex;\n  }\n  .flex > .item.lg-fill {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.lg-fill.flex {\n    display: flex;\n  }\n  .flex > .item.lg-0 {\n    display: none;\n  }\n  .flex > .item.lg-0.flex {\n    display: none;\n  }\n  .flex > .item.lg-1 {\n    display: initial;\n    flex-basis: 8.33333%;\n    flex-grow: 0;\n    max-width: 8.33333%;\n  }\n  .flex > .item.lg-1.flex {\n    display: flex;\n  }\n  .flex > .item.lg-2 {\n    display: initial;\n    flex-basis: 16.66667%;\n    flex-grow: 0;\n    max-width: 16.66667%;\n  }\n  .flex > .item.lg-2.flex {\n    display: flex;\n  }\n  .flex > .item.lg-3 {\n    display: initial;\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex > .item.lg-3.flex {\n    display: flex;\n  }\n  .flex > .item.lg-4 {\n    display: initial;\n    flex-basis: 33.33333%;\n    flex-grow: 0;\n    max-width: 33.33333%;\n  }\n  .flex > .item.lg-4.flex {\n    display: flex;\n  }\n  .flex > .item.lg-5 {\n    display: initial;\n    flex-basis: 41.66667%;\n    flex-grow: 0;\n    max-width: 41.66667%;\n  }\n  .flex > .item.lg-5.flex {\n    display: flex;\n  }\n  .flex > .item.lg-6 {\n    display: initial;\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex > .item.lg-6.flex {\n    display: flex;\n  }\n  .flex > .item.lg-7 {\n    display: initial;\n    flex-basis: 58.33333%;\n    flex-grow: 0;\n    max-width: 58.33333%;\n  }\n  .flex > .item.lg-7.flex {\n    display: flex;\n  }\n  .flex > .item.lg-8 {\n    display: initial;\n    flex-basis: 66.66667%;\n    flex-grow: 0;\n    max-width: 66.66667%;\n  }\n  .flex > .item.lg-8.flex {\n    display: flex;\n  }\n  .flex > .item.lg-9 {\n    display: initial;\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex > .item.lg-9.flex {\n    display: flex;\n  }\n  .flex > .item.lg-10 {\n    display: initial;\n    flex-basis: 83.33333%;\n    flex-grow: 0;\n    max-width: 83.33333%;\n  }\n  .flex > .item.lg-10.flex {\n    display: flex;\n  }\n  .flex > .item.lg-11 {\n    display: initial;\n    flex-basis: 91.66667%;\n    flex-grow: 0;\n    max-width: 91.66667%;\n  }\n  .flex > .item.lg-11.flex {\n    display: flex;\n  }\n  .flex > .item.lg-12 {\n    display: initial;\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex > .item.lg-12.flex {\n    display: flex;\n  }\n}\n@media (min-width: 1920px) {\n  .flex > .item.xl {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.xl.flex {\n    display: flex;\n  }\n  .flex > .item.xl-auto {\n    display: initial;\n    flex-basis: auto;\n    flex-grow: 0;\n    max-width: none;\n  }\n  .flex > .item.xl-auto.flex {\n    display: flex;\n  }\n  .flex > .item.xl-fill {\n    display: initial;\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .flex > .item.xl-fill.flex {\n    display: flex;\n  }\n  .flex > .item.xl-0 {\n    display: none;\n  }\n  .flex > .item.xl-0.flex {\n    display: none;\n  }\n  .flex > .item.xl-1 {\n    display: initial;\n    flex-basis: 8.33333%;\n    flex-grow: 0;\n    max-width: 8.33333%;\n  }\n  .flex > .item.xl-1.flex {\n    display: flex;\n  }\n  .flex > .item.xl-2 {\n    display: initial;\n    flex-basis: 16.66667%;\n    flex-grow: 0;\n    max-width: 16.66667%;\n  }\n  .flex > .item.xl-2.flex {\n    display: flex;\n  }\n  .flex > .item.xl-3 {\n    display: initial;\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex > .item.xl-3.flex {\n    display: flex;\n  }\n  .flex > .item.xl-4 {\n    display: initial;\n    flex-basis: 33.33333%;\n    flex-grow: 0;\n    max-width: 33.33333%;\n  }\n  .flex > .item.xl-4.flex {\n    display: flex;\n  }\n  .flex > .item.xl-5 {\n    display: initial;\n    flex-basis: 41.66667%;\n    flex-grow: 0;\n    max-width: 41.66667%;\n  }\n  .flex > .item.xl-5.flex {\n    display: flex;\n  }\n  .flex > .item.xl-6 {\n    display: initial;\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex > .item.xl-6.flex {\n    display: flex;\n  }\n  .flex > .item.xl-7 {\n    display: initial;\n    flex-basis: 58.33333%;\n    flex-grow: 0;\n    max-width: 58.33333%;\n  }\n  .flex > .item.xl-7.flex {\n    display: flex;\n  }\n  .flex > .item.xl-8 {\n    display: initial;\n    flex-basis: 66.66667%;\n    flex-grow: 0;\n    max-width: 66.66667%;\n  }\n  .flex > .item.xl-8.flex {\n    display: flex;\n  }\n  .flex > .item.xl-9 {\n    display: initial;\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex > .item.xl-9.flex {\n    display: flex;\n  }\n  .flex > .item.xl-10 {\n    display: initial;\n    flex-basis: 83.33333%;\n    flex-grow: 0;\n    max-width: 83.33333%;\n  }\n  .flex > .item.xl-10.flex {\n    display: flex;\n  }\n  .flex > .item.xl-11 {\n    display: initial;\n    flex-basis: 91.66667%;\n    flex-grow: 0;\n    max-width: 91.66667%;\n  }\n  .flex > .item.xl-11.flex {\n    display: flex;\n  }\n  .flex > .item.xl-12 {\n    display: initial;\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex > .item.xl-12.flex {\n    display: flex;\n  }\n}\n.flex.column > .item.size-auto {\n  flex-basis: auto;\n  flex-grow: 0;\n  max-height: none;\n}\n.flex.column > .item.size-fill {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-height: 100%;\n}\n.flex.column > .item.size-0 {\n  flex-basis: 0%;\n  flex-grow: 0;\n  max-height: 0%;\n}\n.flex.column > .item.size-1 {\n  flex-basis: 8.33333%;\n  flex-grow: 0;\n  max-height: 8.33333%;\n}\n.flex.column > .item.size-2 {\n  flex-basis: 16.66667%;\n  flex-grow: 0;\n  max-height: 16.66667%;\n}\n.flex.column > .item.size-3 {\n  flex-basis: 25%;\n  flex-grow: 0;\n  max-height: 25%;\n}\n.flex.column > .item.size-4 {\n  flex-basis: 33.33333%;\n  flex-grow: 0;\n  max-height: 33.33333%;\n}\n.flex.column > .item.size-5 {\n  flex-basis: 41.66667%;\n  flex-grow: 0;\n  max-height: 41.66667%;\n}\n.flex.column > .item.size-6 {\n  flex-basis: 50%;\n  flex-grow: 0;\n  max-height: 50%;\n}\n.flex.column > .item.size-7 {\n  flex-basis: 58.33333%;\n  flex-grow: 0;\n  max-height: 58.33333%;\n}\n.flex.column > .item.size-8 {\n  flex-basis: 66.66667%;\n  flex-grow: 0;\n  max-height: 66.66667%;\n}\n.flex.column > .item.size-9 {\n  flex-basis: 75%;\n  flex-grow: 0;\n  max-height: 75%;\n}\n.flex.column > .item.size-10 {\n  flex-basis: 83.33333%;\n  flex-grow: 0;\n  max-height: 83.33333%;\n}\n.flex.column > .item.size-11 {\n  flex-basis: 91.66667%;\n  flex-grow: 0;\n  max-height: 91.66667%;\n}\n.flex.column > .item.size-12 {\n  flex-basis: 100%;\n  flex-grow: 0;\n  max-height: 100%;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.inline {\n  display: inline;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.block {\n  display: block;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.scrollable {\n  height: 100%;\n  max-height: 100%;\n  max-width: 100%;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n}\n.scrollable.hide-x {\n  overflow-x: hidden;\n}\n.scrollable.hide-y {\n  overflow-y: hidden;\n}\n\n/* stylelint-disable-next-line max-line-length */\n/* TODO: Having different line-heights causes some UI and spacing issues.\n * They should be consistent. Please investigate this when refactoring/reimplementing the Typography.\n*/\n.typo-old.h1 {\n  font-weight: 600;\n  font-size: 4.2857142857rem;\n  letter-spacing: -0.03em;\n  line-height: 1.36;\n}\n\nh1.typo-old {\n  font-weight: 600;\n  font-size: 4.2857142857rem;\n  letter-spacing: -0.03em;\n  line-height: 1.36;\n}\n\n.typo-old.h2 {\n  font-weight: 600;\n  font-size: 3.4285714286rem;\n  letter-spacing: -0.025;\n  line-height: 1.5;\n}\n\nh2.typo-old {\n  font-weight: 600;\n  font-size: 3.4285714286rem;\n  letter-spacing: -0.025;\n  line-height: 1.5;\n}\n\n.typo-old.h3 {\n  font-weight: 600;\n  font-size: 2.4285714286rem;\n  letter-spacing: -0.02em;\n  line-height: 1.6;\n}\n\nh3.typo-old {\n  font-weight: 600;\n  font-size: 2.4285714286rem;\n  letter-spacing: -0.02em;\n  line-height: 1.6;\n}\n\n.typo-old.h4 {\n  font-weight: 600;\n  font-size: 1.7142857143rem;\n  letter-spacing: -0.015em;\n  line-height: 1.7;\n}\n\nh4.typo-old {\n  font-weight: 600;\n  font-size: 1.7142857143rem;\n  letter-spacing: -0.015em;\n  line-height: 1.7;\n}\n\n.typo-old.h5 {\n  font-weight: 600;\n  font-size: 1.4285714286rem;\n  letter-spacing: -0.0125em;\n  line-height: 1.8;\n}\n\nh5.typo-old {\n  font-weight: 600;\n  font-size: 1.4285714286rem;\n  letter-spacing: -0.0125em;\n  line-height: 1.8;\n}\n\n.typo-old.h6 {\n  font-weight: 600;\n  font-size: 1.1428571429rem;\n  letter-spacing: -0.01em;\n  line-height: 1.9;\n}\n\nh6.typo-old {\n  font-weight: 600;\n  font-size: 1.1428571429rem;\n  letter-spacing: -0.01em;\n  line-height: 1.9;\n}\n\n.typo-old.subtitle1 {\n  font-weight: 600;\n  font-size: 1rem;\n  letter-spacing: 0.01em;\n  line-height: 2;\n}\n\nsubtitle1.typo-old {\n  font-weight: 600;\n  font-size: 1rem;\n  letter-spacing: 0.01em;\n  line-height: 2;\n}\n\n.typo-old.subtitle2 {\n  font-weight: 600;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.02em;\n  line-height: 2.15;\n}\n\nsubtitle2.typo-old {\n  font-weight: 600;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.02em;\n  line-height: 2.15;\n}\n\n.typo-old.subtitle3 {\n  font-weight: 600;\n  font-size: 0.7142857143rem;\n  letter-spacing: 0.04em;\n  line-height: 2.4;\n}\n\nsubtitle3.typo-old {\n  font-weight: 600;\n  font-size: 0.7142857143rem;\n  letter-spacing: 0.04em;\n  line-height: 2.4;\n}\n\n.typo-old.body1 {\n  font-size: 1rem;\n  letter-spacing: 0.01em;\n  line-height: 2;\n}\n\nbody1.typo-old {\n  font-size: 1rem;\n  letter-spacing: 0.01em;\n  line-height: 2;\n}\n\n.typo-old.body2 {\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.02em;\n  line-height: 2.15;\n}\n\nbody2.typo-old {\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.02em;\n  line-height: 2.15;\n}\n\n.typo-old.body3 {\n  font-size: 0.7142857143rem;\n  letter-spacing: 0.04em;\n  line-height: 2.4;\n}\n\nbody3.typo-old {\n  font-size: 0.7142857143rem;\n  letter-spacing: 0.04em;\n  line-height: 2.4;\n}\n\n.typo-old {\n  font-family: \"Open Sans\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\" !important;\n}\n.typo-old.weight-light {\n  font-weight: 300 !important;\n}\n.typo-old.weight-normal {\n  font-weight: 400 !important;\n}\n.typo-old.weight-semi-bold {\n  font-weight: 600 !important;\n}\n.typo-old.weight-bold {\n  font-weight: 700 !important;\n}\n.typo-old.nowrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.typo-old.paragraph {\n  margin-bottom: 16px ;\n}\n.typo-old.gutter-bottom {\n  margin-bottom: 0.35em;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-justify {\n  text-align: justify;\n}\n\n.new-typography-wrapper * {\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper h1,\n.new-typography-wrapper h2,\n.new-typography-wrapper h3,\n.new-typography-wrapper h4,\n.new-typography-wrapper h5,\n.new-typography-wrapper h6,\n.new-typography-wrapper p {\n  margin: 0;\n}\n.new-typography-wrapper a {\n  color: #0074e0;\n}\n.new-typography-wrapper a:hover {\n  color: #2392fb;\n}\n.new-typography-wrapper .text-start {\n  text-align: start;\n}\n.new-typography-wrapper .text-end {\n  text-align: end;\n}\n.new-typography-wrapper .text-left {\n  text-align: left;\n}\n.new-typography-wrapper .text-right {\n  text-align: right;\n}\n.new-typography-wrapper .text-center {\n  text-align: center;\n}\n.new-typography-wrapper .text-justify {\n  text-align: justify;\n}\n.new-typography-wrapper .typo.h1 {\n  font-weight: 500;\n  font-size: 1.7142857143rem;\n  letter-spacing: -0.47px;\n  line-height: 34px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper h1 {\n  font-weight: 500;\n  font-size: 1.7142857143rem;\n  letter-spacing: -0.47px;\n  line-height: 34px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.h2 {\n  font-weight: 500;\n  font-size: 1.4285714286rem;\n  letter-spacing: -0.33px;\n  line-height: 30px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper h2 {\n  font-weight: 500;\n  font-size: 1.4285714286rem;\n  letter-spacing: -0.33px;\n  line-height: 30px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.h3 {\n  font-weight: 400;\n  font-size: 1.4285714286rem;\n  letter-spacing: -0.33px;\n  line-height: 30px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper h3 {\n  font-weight: 400;\n  font-size: 1.4285714286rem;\n  letter-spacing: -0.33px;\n  line-height: 30px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.h4 {\n  font-weight: 700;\n  font-size: 1.1428571429rem;\n  letter-spacing: -0.18px;\n  line-height: 24px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper h4 {\n  font-weight: 700;\n  font-size: 1.1428571429rem;\n  letter-spacing: -0.18px;\n  line-height: 24px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.h5 {\n  font-weight: 500;\n  font-size: 1.1428571429rem;\n  letter-spacing: -0.18px;\n  line-height: 24px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper h5 {\n  font-weight: 500;\n  font-size: 1.1428571429rem;\n  letter-spacing: -0.18px;\n  line-height: 24px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.body1 {\n  font-weight: 700;\n  font-size: 1rem;\n  letter-spacing: -0.09px;\n  line-height: 20px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper body1 {\n  font-weight: 700;\n  font-size: 1rem;\n  letter-spacing: -0.09px;\n  line-height: 20px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.body2 {\n  font-weight: 500;\n  font-size: 1rem;\n  letter-spacing: -0.09px;\n  line-height: 20px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper body2 {\n  font-weight: 500;\n  font-size: 1rem;\n  letter-spacing: -0.09px;\n  line-height: 20px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.body3 {\n  font-weight: 400;\n  font-size: 1rem;\n  letter-spacing: -0.09px;\n  line-height: 20px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper body3 {\n  font-weight: 400;\n  font-size: 1rem;\n  letter-spacing: -0.09px;\n  line-height: 20px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.info1 {\n  font-weight: 700;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper info1 {\n  font-weight: 700;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.info2 {\n  font-weight: 500;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper info2 {\n  font-weight: 500;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper .typo.info3 {\n  font-weight: 400;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n.new-typography-wrapper info3 {\n  font-weight: 400;\n  font-size: 0.8571428571rem;\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  font-family: \"Inter\", system-ui, -apple-system, \"Segoe UI\", \"Roboto\", \"Noto Sans\", \"Ubuntu\", \"Cantarell\", \"Helvetica Neue\";\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}","@font-face {\n    font-display: swap;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 400;\n    src:\n        url('./fonts/Inter-Regular.woff2?v=3.19') format('woff2'),\n        url('./fonts/Inter-Regular.woff?v=3.19') format('woff');\n}\n@font-face {\n    font-display: swap;\n    font-family: Inter;\n    font-style: italic;\n    font-weight: 400;\n    src:\n        url('./fonts/Inter-Italic.woff2?v=3.19') format('woff2'),\n        url('./fonts/Inter-Italic.woff?v=3.19') format('woff');\n}\n@font-face {\n    font-display: swap;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 500;\n    src:\n        url('./fonts/Inter-Medium.woff2?v=3.19') format('woff2'),\n        url('./fonts/Inter-Medium.woff?v=3.19') format('woff');\n}\n@font-face {\n    font-display: swap;\n    font-family: Inter;\n    font-style: italic;\n    font-weight: 500;\n    src:\n        url('./fonts/Inter-MediumItalic.woff2?v=3.19') format('woff2'),\n        url('./fonts/Inter-MediumItalic.woff?v=3.19') format('woff');\n}\n@font-face {\n    font-display: swap;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 700;\n    src:\n        url('./fonts/Inter-Bold.woff2?v=3.19') format('woff2'),\n        url('./fonts/Inter-Bold.woff?v=3.19') format('woff');\n}\n@font-face {\n    font-display: swap;\n    font-family: Inter;\n    font-style: italic;\n    font-weight: 700;\n    src:\n        url('./fonts/Inter-BoldItalic.woff2?v=3.19') format('woff2'),\n        url('./fonts/Inter-BoldItalic.woff?v=3.19') format('woff');\n}\n","/* modern-normalize v2.0.0 | https://github.com/sindresorhus/modern-normalize */\n\n*,\n::before,\n::after {\n    box-sizing: border-box;\n\n    /* Disable touch non-standard gestures and also prevent delay in user actions. */\n    touch-action: manipulation;\n\n    /* Reset webkit focus outline */\n    &:focus {\n        outline: none;\n    }\n}\n\nhtml {\n    font-family:\n        system-ui,\n        'Segoe UI',\n        Roboto,\n        Helvetica,\n        Arial,\n        sans-serif,\n        'Apple Color Emoji',\n        'Segoe UI Emoji';\n    line-height: 1.15;\n    tab-size: 4;\n    text-size-adjust: 100%;\n}\n\nbody {\n    margin: 0;\n}\n\nhr {\n    color: inherit;\n    height: 0;\n}\n\nabbr[title] {\n    text-decoration: underline dotted;\n}\n\nb,\nstrong {\n    font-weight: bolder;\n}\n\ncode,\nkbd,\nsamp,\npre {\n    font-family:\n        ui-monospace,\n        SFMono-Regular,\n        Consolas,\n        'Liberation Mono',\n        Menlo,\n        monospace;\n    font-size: 1em;\n}\n\nsmall {\n    font-size: 80%;\n}\n\nsub,\nsup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n}\n\nsub {\n    bottom: -0.25em;\n}\n\nsup {\n    top: -0.5em;\n}\n\ntable {\n    border-color: inherit;\n    text-indent: 0;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n}\n\nbutton,\nselect {\n    text-transform: none;\n}\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n    appearance: button;\n}\n\n::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n}\n\n:-moz-focusring {\n    outline: 1px dotted ButtonText;\n}\n\n:-moz-ui-invalid {\n    box-shadow: none;\n}\n\nlegend {\n    padding: 0;\n}\n\nprogress {\n    vertical-align: baseline;\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n    height: auto;\n}\n\n[type='search'] {\n    appearance: textfield;\n    outline-offset: -2px;\n}\n\n::-webkit-search-decoration {\n    appearance: none;\n}\n\n::-webkit-file-upload-button {\n    appearance: button;\n    font: inherit;\n}\n\nsummary {\n    display: list-item;\n}\n\n/* Reset webkit autofill appearance */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n    background-color: transparent !important;\n    box-shadow: 0 0 0 1000px white inset;\n    transition: background-color 5000s ease-in-out 0s;\n}\n","@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use '../theme';\n\n$spacing: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10;\n$item-sizes: auto, fill, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12;\n\n/* TODO: The way I used displays here is not the best approach;\n * it'll simply fail for something like `flex item xs-0 md-1`.\n * It's just a temporary solution.\n*/\n@mixin generate-row-item-sizes($breakpoint) {\n    &.#{$breakpoint} {\n        display: initial;\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n\n        &.flex {\n            display: flex;\n        }\n    }\n\n    @each $size in $item-sizes {\n        &.#{$breakpoint}-#{$size} {\n            @if $size == auto {\n                display: initial;\n                flex-basis: auto;\n                flex-grow: 0;\n                max-width: none;\n\n                &.flex {\n                    display: flex;\n                }\n            } @else if $size == fill {\n                display: initial;\n                flex-basis: 0;\n                flex-grow: 1;\n                max-width: 100%;\n\n                &.flex {\n                    display: flex;\n                }\n            } @else if $size == 0 {\n                display: none;\n\n                &.flex {\n                    display: none;\n                }\n            } @else {\n                $width: math.div(math.round(math.div($size, 12) * math.pow(10, 7)), math.pow(10, 5)) * 1%;\n\n                display: initial;\n                flex-basis: $width;\n                flex-grow: 0;\n                max-width: $width;\n\n                &.flex {\n                    display: flex;\n                }\n            }\n        }\n    }\n}\n\n.flex {\n    box-sizing: border-box;\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n\n    &.inline {\n        display: inline-flex;\n        width: auto;\n    }\n\n    &.auto-width {\n        width: auto;\n    }\n\n    &.row {\n        flex-direction: row;\n    }\n\n    &.column {\n        flex-direction: column;\n        height: 100%;\n        width: auto;\n\n        &-reverse {\n            flex-direction: column-reverse;\n        }\n    }\n\n    &.reverse {\n        flex-direction: row-reverse;\n    }\n\n    &.nowrap {\n        flex-wrap: nowrap;\n    }\n\n    &.wrap-reverse {\n        flex-wrap: wrap-reverse;\n    }\n\n    &.items-start {\n        align-items: flex-start;\n    }\n\n    &.items-end {\n        align-items: flex-end;\n    }\n\n    &.items-center {\n        align-items: center;\n    }\n\n    &.items-baseline {\n        align-items: baseline;\n    }\n\n    &.items-stretch {\n        align-items: stretch;\n    }\n\n    &.content-start {\n        align-content: flex-start;\n    }\n\n    &.content-end {\n        align-content: flex-end;\n    }\n\n    &.content-center {\n        align-content: center;\n    }\n\n    &.content-between {\n        align-content: space-between;\n    }\n\n    &.content-around {\n        align-content: space-around;\n    }\n\n    &.content-evenly {\n        align-content: space-evenly;\n    }\n\n    &.justify-start {\n        justify-content: flex-start;\n    }\n\n    &.justify-end {\n        justify-content: flex-end;\n    }\n\n    &.justify-center {\n        justify-content: center;\n    }\n\n    &.justify-between {\n        justify-content: space-between;\n    }\n\n    &.justify-around {\n        justify-content: space-around;\n    }\n\n    &.justify-evenly {\n        justify-content: space-evenly;\n    }\n\n    @each $space in $spacing {\n        $offset: math.div(theme.$base-space * $space, 2);\n        &.space-#{$space} {\n            margin: $offset * -1;\n            width: calc(100% + #{2 * $offset});\n\n            > .item {\n                padding: $offset;\n            }\n        }\n    }\n\n    > .item {\n        box-sizing: border-box;\n\n        &.zero-min-width {\n            min-width: 0 !important;\n        }\n\n        // stylelint-disable max-nesting-depth\n        @each $breakpoint in map.keys(theme.$breakpoints) {\n            @if $breakpoint == xs {\n                @include generate-row-item-sizes($breakpoint);\n            } @else {\n                @include theme.mq-up($breakpoint) {\n                    @include generate-row-item-sizes($breakpoint);\n                }\n            }\n        }\n    }\n\n    &.column > .item {\n        @each $size in $item-sizes {\n            &.size-#{$size} {\n                @if $size == auto {\n                    flex-basis: auto;\n                    flex-grow: 0;\n                    max-height: none;\n                } @else if $size == fill {\n                    flex-basis: 0;\n                    flex-grow: 1;\n                    max-height: 100%;\n                } @else {\n                    $height: math.div(math.round(math.div($size, 12) * math.pow(10, 7)), math.pow(10, 5)) * 1%;\n\n                    flex-basis: $height;\n                    flex-grow: 0;\n                    max-height: $height;\n                }\n            }\n        }\n    }\n}\n","@use 'sass:list';\n@use 'sass:map';\n\n$breakpoints: (\n    xs: 0,\n    sm: 600px,\n    md: 960px,\n    lg: 1280px,\n    xl: 1920px,\n);\n$breakpoint-keys: map.keys($breakpoints);\n$breakpoint-unit: px;\n$breakpoint-step: 0.05;\n\n@function breakpoint($breakpointName: xs) {\n    @return map.get($breakpoints, $breakpointName);\n}\n\n@mixin mq-up($breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index > 1 {\n            @media (min-width: map.get($breakpoints, $breakpoint)) {\n                @content;\n            }\n        } @else {\n            @content;\n\n            // stylelint-disable-next-line max-nesting-depth\n            @if $show-warning {\n                @warn 'Using #{$breakpoint} breakpoint as mq-up is redundant. Remove the media query.';\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-down($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $upper-index: list.index($breakpoint-keys, $breakpoint) + 1;\n\n        @if $upper-index == list.length($breakpoint-keys) + 1 {\n            $lowest-breakpoint-key: list.nth($breakpoint-keys, 1);\n\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-down is redundant. Use mq-up(#{$lowest-breakpoint-key}) instead.';\n\n            @include mq-up($lowest-breakpoint-key, false) {\n                @content;\n            }\n        } @else {\n            $upper-breakpoint-key: list.nth($breakpoint-keys, $upper-index);\n\n            @media (max-width: map.get($breakpoints, $upper-breakpoint-key) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-between($start-breakpoint, $end-breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $start-breakpoint) and map.has-key($breakpoints, $end-breakpoint) {\n        $start-index: list.index($breakpoint-keys, $start-breakpoint);\n        $end-index: list.index($breakpoint-keys, $end-breakpoint);\n\n        @if $end-index == list.length($breakpoint-keys) {\n            @if $show-warning {\n                /* stylelint-disable-next-line max-line-length */\n                @warn 'Using #{$end-breakpoint} breakpoint as mq-betwen end is redundant. Use mq-up(#{$start-breakpoint}) instead.';\n            }\n\n            @include mq-up($start-breakpoint) {\n                @content;\n            }\n        } @else {\n            @if $start-index == $end-index {\n                @if $show-warning {\n                    @warn 'Start and end breakpoints are the same. Use mq-only(#{$start-breakpoint}) instead.';\n                }\n            } @else if $start-index > $end-index {\n                @if $show-warning {\n                    /* stylelint-disable-next-line max-line-length */\n                    @warn 'Start breakpoint (#{$start-breakpoint}) is bigger than end breakpoint (#{$end-breakpoint}). Remove it or change it.';\n                }\n            }\n\n            $upper-breakpoint: list.nth($breakpoint-keys, $end-index + 1);\n\n            @media\n                (min-width: map.get($breakpoints, $start-breakpoint)) and\n                (max-width: map.get($breakpoints, $upper-breakpoint) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Both or one of the given breakpoints (#{$start-breakpoint}, #{$end-breakpoint}) is missing.';\n    }\n}\n\n@mixin mq-only($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index == list.length($breakpoint-keys) {\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-only parameter is redundant. Use mq-up(#{$breakpoint}) instead.';\n\n            @include mq-up($breakpoint) {\n                @content;\n            }\n        } @else {\n            @include mq-between($breakpoint, $breakpoint, false) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq($condition, $breakpoint-one, $breakpoint-two: null) {\n    @if ($condition == up) {\n        @include mq-up($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == down) {\n        @include mq-down($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == between) {\n        @include mq-between($breakpoint-one, $breakpoint-two) {\n            @content;\n        }\n    } @else if ($condition == only) {\n        @include mq-only($breakpoint-one) {\n            @content;\n        }\n    }\n}\n",".full-width {\n    width: 100%;\n}\n\n.full-height {\n    height: 100%;\n}\n\n// Display classes\n.inline {\n    display: inline;\n}\n\n.inline-block {\n    display: inline-block;\n}\n\n.block {\n    display: block;\n}\n\n// Position classes\n.relative {\n    position: relative;\n}\n\n.fixed {\n    position: fixed;\n}\n\n.absolute {\n    position: absolute;\n}\n\n// Scrollable\n.scrollable {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    width: 100%;\n\n    &.hide-x {\n        overflow-x: hidden;\n    }\n\n    &.hide-y {\n        overflow-y: hidden;\n    }\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n/* stylelint-disable-next-line max-line-length */\n$typography-font-family: 'Open Sans', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue';\n$typography-font-weights: (\n    light: 300,\n    normal: 400,\n    semi-bold: 600,\n    bold: 700\n);\n\n/* TODO: Having different line-heights causes some UI and spacing issues.\n * They should be consistent. Please investigate this when refactoring/reimplementing the Typography.\n*/\n$typography-variants: (\n    h1: 60px semi-bold 1.36 -0.03em,\n    h2: 48px semi-bold 1.5 -0.025,\n    h3: 34px semi-bold 1.6 -0.02em,\n    h4: 24px semi-bold 1.7 -0.015em,\n    h5: 20px semi-bold 1.8 -0.0125em,\n    h6: 16px semi-bold 1.9 -0.01em,\n    subtitle1: 14px semi-bold 2 0.01em,\n    subtitle2: 12px semi-bold 2.15 0.02em,\n    subtitle3: 10px semi-bold 2.4 0.04em,\n    body1: 14px regular 2 0.01em,\n    body2: 12px regular 2.15 0.02em,\n    body3: 10px regular 2.4 0.04em,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing, $text-transform: null) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n    text-transform: $text-transform;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo-old($variant, $includeFontFamily: false) {\n    @if $includeFontFamily {\n        font-family: $typography-font-family;\n    }\n\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n}\n","@use 'sass:list';\n@use 'sass:map';\n@use '../theme_old';\n\n$heading-variants: h1, h2, h3, h4, h5, h6;\n\n@each $variant in map-keys(theme_old.$typography-variants) {\n    .typo-old.#{$variant} {\n        @include theme_old.typo-old($variant);\n    }\n\n    @if list.index($heading-variants, $variant) != false {\n        #{$variant}.typo-old {\n            @include theme_old.typo-old($variant);\n        }\n    }\n}\n\n.typo-old {\n    font-family: theme_old.$typography-font-family !important;\n\n    @each $weight in map.keys(theme_old.$typography-font-weights) {\n        &.weight-#{$weight} {\n            @include theme_old.font-weight($weight, true);\n        }\n    }\n\n    &.nowrap {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &.paragraph {\n        margin-bottom: theme_old.spacing(2);\n    }\n\n    &.gutter-bottom {\n        margin-bottom: 0.35em;\n    }\n}\n\n// Text Alignment\n$text-align-list: left, right, center, justify;\n\n@each $align in $text-align-list {\n    .text-#{$align} {\n        text-align: $align;\n    }\n}\n","@use 'sass:list';\n@use 'sass:map';\n@use '../theme';\n\n.new-typography-wrapper {\n    $heading-variants: h1, h2, h3, h4, h5;\n    $text-align-list: start, end, left, right, center, justify;\n\n    * {\n        font-family: theme.$typography-font-family;\n    }\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    p {\n        margin: 0;\n    }\n\n    a {\n        color: theme.color(ocean-500);\n\n        &:hover {\n            color: theme.color(ocean-400);\n        }\n    }\n\n    @each $align in $text-align-list {\n        .text-#{$align} {\n            text-align: $align;\n        }\n    }\n    @each $variant in map-keys(theme.$typography-variants) {\n        .typo.#{$variant} {\n            @include theme.typo($variant);\n        }\n\n        // Heading elements\n        @if list.index($heading-variants, $variant) != false {\n            #{$variant} {\n                @include theme.typo($variant);\n            }\n        }\n    }\n}\n\n.truncate {\n    @include theme.truncate();\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
